var _a, _b, _c, _d, _e, _f, _g, _h;
import { alpha, Tooltip, responsiveFontSizes, createTheme } from "@mui/material";
import { c as commonPalette } from "../palette-utils-BHqJlHm9.js";
import { g } from "../palette-utils-BHqJlHm9.js";
import { jsxs, Fragment, jsx } from "react/jsx-runtime";
import { T as Typography, a as TablePaginationActions, I as ICON_SIZE_LARGE, b as ICON_SIZE_MEDIUM, c as ICON_SIZE_SMALL, g as getSpacing, e as ellipsisStyles, M as MENU_ITEM_SIZE_DEFAULT, d as MENU_LIST_MAX_SIZE, f as MENU_ITEM_SIZE_DENSE, A as APPBAR_SIZE, B as BREAKPOINTS, S as SPACING } from "../css-utils-CjUBRJVK.js";
import { h, N } from "../css-utils-CjUBRJVK.js";
import { Cancel, EventOutlined, ChevronRightOutlined, ChevronLeftOutlined, ExpandMoreOutlined, CheckCircleOutlined, InfoOutlined } from "@mui/icons-material";
import { A as ArrowDown } from "../ArrowDown-d6bxUL0F.js";
import { renderDigitalClockTimeView } from "@mui/x-date-pickers";
import { M as MenuItem } from "../MenuItem-DRUK149i.js";
const themeShadows = [
  "none",
  // 0
  "0px 2px 1px -1px rgba(44, 48, 50, 0.12), 0px 1px 1px rgba(44, 48, 50, 0.08), 0px 1px 3px rgba(44, 48, 50, 0.04)",
  // 1
  "0px 3px 1px -2px rgba(44, 48, 50, 0.12), 0px 2px 2px rgba(44, 48, 50, 0.08), 0px 1px 5px rgba(44, 48, 50, 0.04)",
  // 2
  "0px 3px 3px -2px rgba(0,0,0,0.16),0px 3px 4px 0px rgba(0,0,0,0.08),0px 1px 8px 0px rgba(0,0,0,0.04)",
  "0px 2px 4px -1px rgba(44, 48, 50, 0.12), 0px 4px 5px rgba(44, 48, 50, 0.08), 0px 1px 10px rgba(44, 48, 50, 0.04)",
  // 4
  "0px 3px 5px -1px rgba(0,0,0,0.16),0px 5px 8px 0px rgba(0,0,0,0.08),0px 1px 14px 0px rgba(0,0,0,0.04)",
  "0px 3px 5px -1px rgba(44, 48, 50, 0.12), 0px 6px 10px rgba(44, 48, 50, 0.08), 0px 1px 18px rgba(44, 48, 50, 0.04)",
  // 6
  "0px 4px 5px -2px rgba(0,0,0,0.16),0px 7px 10px 1px rgba(0,0,0,0.08),0px 2px 16px 1px rgba(0,0,0,0.04)",
  "0px 5px 5px -3px rgba(44, 48, 50, 0.12), 0px 8px 10px 1px rgba(44, 48, 50, 0.08), 0px 3px 14px 2px rgba(44, 48, 50, 0.04)",
  // 8
  "0px 5px 6px -3px rgba(0,0,0,0.16),0px 9px 12px 1px rgba(0,0,0,0.08),0px 3px 16px 2px rgba(0,0,0,0.04)",
  "0px 6px 6px -3px rgba(0,0,0,0.16),0px 10px 14px 1px rgba(0,0,0,0.08),0px 4px 18px 3px rgba(0,0,0,0.04)",
  "0px 6px 7px -4px rgba(0,0,0,0.16),0px 11px 15px 1px rgba(0,0,0,0.08),0px 4px 20px 3px rgba(0,0,0,0.04)",
  "0px 7px 8px -4px rgba(0,0,0,0.16),0px 12px 17px 2px rgba(0,0,0,0.08),0px 5px 22px 4px rgba(0,0,0,0.04)",
  "0px 7px 8px -4px rgba(0,0,0,0.16),0px 13px 19px 2px rgba(0,0,0,0.08),0px 5px 24px 4px rgba(0,0,0,0.04)",
  "0px 7px 9px -4px rgba(0,0,0,0.16),0px 14px 21px 2px rgba(0,0,0,0.08),0px 5px 26px 4px rgba(0,0,0,0.04)",
  "0px 8px 9px -5px rgba(0,0,0,0.16),0px 15px 22px 2px rgba(0,0,0,0.08),0px 6px 28px 5px rgba(0,0,0,0.04)",
  "0px 8px 10px -5px rgba(44, 48, 50, 0.12), 0px 16px 24px 2px rgba(44, 48, 50, 0.08), 0px 6px 30px 5px rgba(44, 48, 50, 0.04)",
  // 16
  "0px 8px 11px -5px rgba(0,0,0,0.16),0px 17px 26px 2px rgba(0,0,0,0.08),0px 6px 32px 5px rgba(0,0,0,0.04)",
  "0px 9px 11px -5px rgba(0,0,0,0.16),0px 18px 28px 2px rgba(0,0,0,0.08),0px 7px 34px 6px rgba(0,0,0,0.04)",
  "0px 9px 12px -6px rgba(0,0,0,0.16),0px 19px 29px 2px rgba(0,0,0,0.08),0px 7px 36px 6px rgba(0,0,0,0.04)",
  "0px 10px 13px -6px rgba(0,0,0,0.16),0px 20px 31px 3px rgba(0,0,0,0.08),0px 8px 38px 7px rgba(0,0,0,0.04)",
  "0px 10px 13px -6px rgba(0,0,0,0.16),0px 21px 33px 3px rgba(0,0,0,0.08),0px 8px 40px 7px rgba(0,0,0,0.04)",
  "0px 10px 14px -6px rgba(0,0,0,0.16),0px 22px 35px 3px rgba(0,0,0,0.08),0px 8px 42px 7px rgba(0,0,0,0.04)",
  "0px 11px 14px -7px rgba(0,0,0,0.16),0px 23px 36px 3px rgba(0,0,0,0.08),0px 9px 44px 8px rgba(0,0,0,0.04)",
  "0px 11px 15px -7px rgba(44, 48, 50, 0.12), 0px 24px 38px 3px rgba(44, 48, 50, 0.08), 0px 9px 46px 8px rgba(44, 48, 50, 0.04)"
  // 24
];
function getPixelToRem(px) {
  const fontBase = 16;
  const rem = 1 / fontBase * px + "rem";
  return rem;
}
const baseTypography = {
  htmlFontSize: 16,
  fontFamily: "Inter, sans-serif",
  fontSize: 16,
  lineHeight: 1.5,
  fontWeightLight: 300,
  fontWeightRegular: 400,
  fontWeightMedium: 500,
  fontWeightBold: 600,
  fontSmoothing: "antialiased",
  h1: {
    fontFamily: "Inter, sans-serif",
    fontWeight: 600,
    fontSize: getPixelToRem(96),
    lineHeight: 1.167,
    letterSpacing: "-1.5px"
  },
  h2: {
    fontFamily: "Inter, sans-serif",
    fontWeight: 600,
    fontSize: getPixelToRem(60),
    lineHeight: 1.2,
    letterSpacing: "-0.5px"
  },
  h3: {
    fontFamily: "Inter, sans-serif",
    fontWeight: 600,
    fontSize: getPixelToRem(48),
    lineHeight: 1.167,
    letterSpacing: 0
  },
  h4: {
    fontFamily: "Inter, sans-serif",
    fontWeight: 600,
    fontSize: getPixelToRem(32),
    lineHeight: 1.25,
    letterSpacing: 0
  },
  h5: {
    fontFamily: "Inter, sans-serif",
    fontWeight: 600,
    fontSize: getPixelToRem(24),
    lineHeight: 1.167,
    letterSpacing: 0
  },
  h6: {
    fontFamily: "Inter, sans-serif",
    fontWeight: 500,
    fontSize: getPixelToRem(18),
    lineHeight: 1.333,
    letterSpacing: 0
  },
  subtitle1: {
    fontFamily: "Inter, sans-serif",
    fontWeight: 500,
    fontSize: getPixelToRem(16),
    lineHeight: 1.5,
    letterSpacing: 0
  },
  subtitle2: {
    fontFamily: "Inter, sans-serif",
    fontWeight: 600,
    fontSize: getPixelToRem(13),
    lineHeight: 1.538,
    letterSpacing: 0
  },
  body1: {
    fontFamily: "Inter, sans-serif",
    fontWeight: 400,
    fontSize: getPixelToRem(16),
    lineHeight: 1.5,
    letterSpacing: 0
  },
  body2: {
    fontFamily: "Inter, sans-serif",
    fontWeight: 400,
    fontSize: getPixelToRem(13),
    lineHeight: 1.538,
    letterSpacing: 0
  },
  button: {
    fontFamily: "Inter, sans-serif",
    fontWeight: 500,
    fontSize: getPixelToRem(13),
    lineHeight: 1.538,
    letterSpacing: 0,
    textTransform: "inherit"
  },
  caption: {
    fontFamily: "Inter, sans-serif",
    fontWeight: 400,
    fontSize: getPixelToRem(11),
    lineHeight: 1.454,
    letterSpacing: 0
  },
  overline: {
    fontFamily: "Inter, sans-serif",
    fontWeight: 500,
    fontSize: getPixelToRem(10),
    lineHeight: 1.2,
    letterSpacing: "1.2px",
    textTransform: "uppercase"
  }
};
const customTypography = {
  captionMedium: {
    ...baseTypography.caption,
    fontWeight: 500,
    letterSpacing: 0
  },
  overlineDelicate: {
    ...baseTypography.overline,
    fontWeight: 400,
    letterSpacing: "1.2px"
  },
  code1: {
    fontFamily: '"Overpass Mono", monospace',
    fontWeight: 400,
    fontSize: getPixelToRem(16),
    lineHeight: 1.5,
    letterSpacing: 0,
    fontVariantLigatures: "no-common-ligatures"
  },
  code2: {
    fontFamily: '"Overpass Mono", monospace',
    fontWeight: 400,
    fontSize: getPixelToRem(14),
    lineHeight: 1.428,
    letterSpacing: 0,
    fontVariantLigatures: "no-common-ligatures"
  },
  code3: {
    fontFamily: '"Overpass Mono", monospace',
    fontWeight: 400,
    fontSize: getPixelToRem(12),
    lineHeight: 1.333,
    letterSpacing: 0,
    fontVariantLigatures: "no-common-ligatures"
  }
};
const themeTypography = {
  ...baseTypography,
  ...customTypography
};
const tooltipArrowSize = 1;
const tooltipSeparation = 0.5;
const tooltipMargin = tooltipArrowSize + tooltipSeparation;
const avatarFallbackImage = "M12 5.9c1.16 0 2.1.94 2.1 2.1s-.94 2.1-2.1 2.1S9.9 9.16 9.9 8s.94-2.1 2.1-2.1m0 9c2.97 0 6.1 1.46 6.1 2.1v1.1H5.9V17c0-.64 3.13-2.1 6.1-2.1M12 4C9.79 4 8 5.79 8 8s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm0 9c-2.67 0-8 1.34-8 4v3h16v-3c0-2.66-5.33-4-8-4z";
const avatarCircularRadius = "50%";
const avatarRoundedRadius = 0.5;
const dataDisplayOverrides = {
  // Divider
  MuiDivider: {
    defaultProps: {
      role: "separator"
    },
    styleOverrides: {
      root: ({ theme: theme2 }) => ({
        backgroundColor: "transparent",
        borderColor: theme2.palette.divider
      }),
      light: ({ theme: theme2 }) => ({
        borderColor: theme2.palette.white[12]
      })
    }
  },
  // Tooltip
  MuiTooltip: {
    defaultProps: {
      arrow: true,
      placement: "top",
      enterDelay: 1e3,
      leaveDelay: 200
    },
    styleOverrides: {
      tooltip: ({ theme: theme2 }) => ({
        ...theme2.typography.caption,
        fontWeight: 500,
        maxWidth: "240px",
        backgroundColor: theme2.palette.black[90],
        '.MuiTooltip-popper[data-popper-placement*="top"] &': {
          marginBottom: theme2.spacing(tooltipSeparation),
          "&.MuiTooltip-tooltipArrow": {
            marginBottom: theme2.spacing(tooltipMargin)
          }
        },
        '.MuiTooltip-popper[data-popper-placement*="right"] &': {
          marginLeft: theme2.spacing(tooltipSeparation),
          "&.MuiTooltip-tooltipArrow": {
            marginLeft: theme2.spacing(tooltipMargin)
          }
        },
        '.MuiTooltip-popper[data-popper-placement*="bottom"] &': {
          marginTop: theme2.spacing(tooltipSeparation),
          "&.MuiTooltip-tooltipArrow": {
            marginTop: theme2.spacing(tooltipMargin)
          }
        },
        '.MuiTooltip-popper[data-popper-placement*="left"] &': {
          marginRight: theme2.spacing(tooltipSeparation),
          "&.MuiTooltip-tooltipArrow": {
            marginRight: theme2.spacing(tooltipMargin)
          }
        }
      }),
      arrow: ({ theme: theme2 }) => ({
        height: theme2.spacing(tooltipArrowSize),
        color: theme2.palette.black[90]
      })
    }
  },
  // Popper
  MuiPopper: {
    styleOverrides: {
      root: ({ theme: theme2 }) => ({
        "& .MuiPaper-root": {
          marginTop: theme2.spacing(0.5)
        }
      })
    }
  },
  // Popover
  MuiPopover: {
    styleOverrides: {
      root: ({ theme: theme2 }) => ({
        "& .MuiPaper-root": {
          marginTop: theme2.spacing(0.5)
        }
      })
    }
  },
  // Dialog
  MuiDialog: {
    defaultProps: {
      maxWidth: "md"
    }
  },
  MuiDialogTitle: {
    defaultProps: {
      variant: "subtitle1"
    },
    styleOverrides: {
      root: ({ theme: theme2 }) => ({
        padding: theme2.spacing(3, 3, 2)
      })
    }
  },
  MuiDialogContent: {
    styleOverrides: {
      root: ({ theme: theme2 }) => ({
        "& .MuiFormGroup-root": {
          padding: theme2.spacing(1, 0)
        }
      })
    }
  },
  MuiDialogContentText: {
    defaultProps: {
      variant: "body2"
    },
    styleOverrides: {
      root: ({ theme: theme2 }) => ({
        color: theme2.palette.text.primary
      })
    }
  },
  // Table
  MuiTablePagination: {
    defaultProps: {
      SelectProps: {
        variant: "outlined",
        size: "small"
      },
      labelDisplayedRows: ({ from, to, count }) => {
        return /* @__PURE__ */ jsxs(Fragment, { children: [
          /* @__PURE__ */ jsx(
            Typography,
            {
              component: "span",
              variant: "inherit",
              weight: "strong",
              color: "textPrimary",
              children: `${from}-${to}`
            }
          ),
          ` of ${count}`
        ] });
      },
      ActionsComponent: TablePaginationActions
    },
    styleOverrides: {
      root: () => ({
        borderBottom: 0
      }),
      toolbar: ({ theme: theme2 }) => ({
        minHeight: "0 !important",
        padding: "0 !important",
        height: theme2.spacing(6)
      }),
      selectLabel: ({ theme: theme2 }) => ({
        margin: 0,
        ...theme2.typography.caption,
        fontWeight: theme2.typography.fontWeightMedium
      }),
      selectIcon: ({ theme: theme2 }) => ({
        "&.MuiSvgIcon-root": {
          right: theme2.spacing(1)
        }
      }),
      input: ({ theme: theme2 }) => ({
        marginRight: theme2.spacing(2),
        marginLeft: theme2.spacing(1),
        width: "auto",
        paddingRight: theme2.spacing(3)
      }),
      displayedRows: ({ theme: theme2 }) => ({
        color: theme2.palette.text.secondary
      })
    }
  },
  MuiTable: {
    defaultProps: {
      stickyHeader: true
    }
  },
  MuiTableRow: {
    styleOverrides: {
      root: ({ theme: theme2 }) => ({
        transition: "background-color 0.25s ease",
        borderColor: theme2.palette.divider,
        "&.MuiTableRow-hover:hover": {
          cursor: "pointer"
        }
      })
    }
  },
  MuiTableCell: {
    styleOverrides: {
      root: ({ theme: theme2 }) => ({
        padding: theme2.spacing(0.5, 2),
        height: theme2.spacing(6),
        "&.MuiTableCell-sizeSmall": {
          height: theme2.spacing(4)
        },
        "&.MuiTableCell-footer": {
          padding: 0
        }
      }),
      head: ({ theme: theme2 }) => ({
        ...theme2.typography.caption,
        fontWeight: theme2.typography.fontWeightMedium,
        color: theme2.palette.text.primary
      }),
      stickyHeader: ({ theme: theme2 }) => ({
        backgroundColor: theme2.palette.common.white
      }),
      paddingCheckbox: ({ theme: theme2 }) => ({
        padding: theme2.spacing(0.5, 1)
      }),
      paddingNone: () => ({
        padding: 0
      })
    }
  },
  // Chip
  MuiChip: {
    defaultProps: {
      color: "primary"
    },
    styleOverrides: {
      root: ({ theme: theme2 }) => ({
        maxWidth: "192px",
        padding: theme2.spacing(0, 0.5),
        "& .MuiAvatar-root": {
          width: ICON_SIZE_LARGE,
          minWidth: ICON_SIZE_LARGE,
          height: ICON_SIZE_LARGE,
          margin: 0,
          color: theme2.palette.secondary.contrastText,
          backgroundColor: theme2.palette.background.paper,
          border: `1px solid ${theme2.palette.action.hover}`
        },
        "& .MuiChip-icon": {
          margin: 0,
          marginLeft: theme2.spacing(0.5)
        },
        "& img": {
          width: ICON_SIZE_LARGE,
          minWidth: ICON_SIZE_LARGE,
          height: ICON_SIZE_LARGE
        },
        "&.MuiChip-root.Mui-disabled": {
          color: theme2.palette.text.disabled,
          backgroundColor: theme2.palette.action.disabledBackground,
          opacity: 1,
          "& .MuiChip-deleteIcon, & .MuiChip-icon": {
            color: theme2.palette.action.disabled
          },
          "& .MuiAvatar-root": {
            opacity: 0.6
          }
        },
        "& .MuiChip-deleteIcon": {
          color: theme2.palette.text.hint
        }
      }),
      // Variants
      filled: ({ theme: theme2 }) => ({
        border: 0,
        backgroundColor: theme2.palette.default.main,
        "& .MuiChip-iconColorPrimary": {
          color: theme2.palette.primary.contrastText
        },
        "& .MuiChip-deleteIcon:hover": {
          color: theme2.palette.text.primary
        }
      }),
      filledPrimary: ({ theme: theme2 }) => ({
        backgroundColor: theme2.palette.primary.main,
        "& .MuiChip-deleteIcon": {
          color: theme2.palette.white[60],
          "&:hover": {
            color: theme2.palette.common.white
          }
        }
      }),
      filledSecondary: ({ theme: theme2 }) => ({
        backgroundColor: theme2.palette.secondary.main
      }),
      outlined: ({ theme: theme2 }) => ({
        borderColor: theme2.palette.default.outlinedBorder,
        "&.MuiChip-root.Mui-disabled": {
          borderColor: theme2.palette.default.outlinedBorder,
          backgroundColor: "transparent"
        },
        "& .MuiChip-deleteIcon:hover": {
          color: theme2.palette.text.primary
        }
      }),
      outlinedPrimary: ({ theme: theme2 }) => ({
        borderColor: theme2.palette.primary.main
      }),
      outlinedSecondary: ({ theme: theme2 }) => ({
        borderColor: theme2.palette.secondary.main
      }),
      // Status colors
      colorSuccess: ({ theme: theme2 }) => ({
        "&.MuiChip-outlined": {
          color: theme2.palette.success.dark,
          borderColor: theme2.palette.success.main
        },
        "&.MuiChip-filled": {
          color: theme2.palette.success.dark,
          backgroundColor: theme2.palette.success.relatedLight
        },
        "& .MuiChip-icon": {
          color: theme2.palette.success.main
        }
      }),
      colorInfo: ({ theme: theme2 }) => ({
        "&.MuiChip-outlined": {
          color: theme2.palette.primary.dark,
          borderColor: theme2.palette.primary.main
        },
        "&.MuiChip-filled": {
          color: theme2.palette.primary.dark,
          backgroundColor: theme2.palette.primary.relatedLight
        },
        "& .MuiChip-icon": {
          color: theme2.palette.info.main
        }
      }),
      colorError: ({ theme: theme2 }) => ({
        "&.MuiChip-outlined": {
          color: theme2.palette.error.dark,
          borderColor: theme2.palette.error.main
        },
        "&.MuiChip-filled": {
          color: theme2.palette.error.dark,
          backgroundColor: theme2.palette.error.relatedLight
        },
        "& .MuiChip-icon": {
          color: theme2.palette.error.main
        }
      }),
      colorWarning: ({ theme: theme2 }) => ({
        "&.MuiChip-outlined": {
          color: theme2.palette.warning.relatedDark,
          borderColor: theme2.palette.warning.main
        },
        "&.MuiChip-filled": {
          color: theme2.palette.warning.relatedDark,
          backgroundColor: theme2.palette.warning.relatedLight
        },
        "& .MuiChip-icon": {
          color: theme2.palette.warning.main
        }
      }),
      // Sizes
      sizeSmall: ({ theme: theme2 }) => ({
        "& img": {
          width: ICON_SIZE_MEDIUM,
          minWidth: ICON_SIZE_MEDIUM,
          height: ICON_SIZE_MEDIUM
        },
        "& .MuiAvatar-root": {
          width: ICON_SIZE_MEDIUM,
          minWidth: ICON_SIZE_MEDIUM,
          height: ICON_SIZE_MEDIUM
        },
        "& .MuiChip-icon": {
          marginLeft: theme2.spacing(0.25)
        }
      }),
      // Inner elements
      label: ({ theme: theme2 }) => ({
        ...theme2.typography.button,
        padding: theme2.spacing(0, 0.75)
      }),
      labelSmall: ({ theme: theme2 }) => ({
        ...theme2.typography.caption,
        fontWeight: 500,
        padding: theme2.spacing(0, 0.5)
      }),
      deleteIcon: () => ({
        width: ICON_SIZE_MEDIUM,
        height: ICON_SIZE_MEDIUM,
        margin: 0,
        marginLeft: "2px",
        // Forced to a non-standard value to meet with design
        marginRight: "3px",
        // Forced to a non-standard value to meet with design
        transition: "color 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms"
      }),
      deleteIconSmall: ({ theme: theme2 }) => ({
        width: theme2.spacing(2),
        height: theme2.spacing(2),
        marginRight: 0
      }),
      clickable: ({ theme: theme2 }) => ({
        "&:active": {
          boxShadow: "none"
        },
        "&.MuiChip-outlined": {
          transitionProperty: "background, color, border-color",
          transitionDuration: "300ms",
          transitionTimingFunction: "cubic-bezier(0.4, 0, 0.2, 1)",
          "&:hover": {
            backgroundColor: "transparent",
            "&.MuiChip-colorPrimary": {
              color: theme2.palette.primary.dark,
              borderColor: theme2.palette.primary.dark
            },
            "&.MuiChip-colorSecondary": {
              color: theme2.palette.secondary.dark,
              borderColor: theme2.palette.secondary.dark
            },
            "&.MuiChip-colorDefault": {
              borderColor: theme2.palette.default.dark
            },
            "&.MuiChip-colorSuccess": {
              color: theme2.palette.success.dark,
              borderColor: theme2.palette.success.dark
            },
            "&.MuiChip-colorInfo": {
              color: theme2.palette.info.dark,
              borderColor: theme2.palette.info.dark
            },
            "&.MuiChip-colorError": {
              color: theme2.palette.error.dark,
              borderColor: theme2.palette.error.dark
            },
            "&.MuiChip-colorWarning": {
              color: theme2.palette.warning.dark,
              borderColor: theme2.palette.warning.dark
            }
          }
        },
        "&.MuiChip-filled": {
          "&:hover": {
            "&.MuiChip-colorSecondary": {
              backgroundColor: theme2.palette.secondary.light
            },
            "&.MuiChip-colorDefault": {
              backgroundColor: theme2.palette.default.dark
            },
            "&.MuiChip-colorSuccess": {
              backgroundColor: alpha(theme2.palette.success.main, 0.25)
            },
            "&.MuiChip-colorInfo": {
              backgroundColor: alpha(theme2.palette.info.main, 0.12)
            },
            "&.MuiChip-colorError": {
              backgroundColor: alpha(theme2.palette.error.main, 0.12)
            },
            "&.MuiChip-colorWarning": {
              backgroundColor: alpha(theme2.palette.warning.main, 0.25)
            }
          }
        }
      })
    }
  },
  // Avatar
  MuiAvatar: {
    defaultProps: {
      size: "medium"
    },
    styleOverrides: {
      root: ({ theme: theme2, ownerState }) => ({
        overflow: "initial",
        color: theme2.palette.secondary.contrastText,
        backgroundColor: theme2.palette.secondary.main,
        //  Default fallback image override
        // https://github.com/mui/material-ui/issues/33229
        "& .MuiAvatar-fallback": {
          path: {
            d: `path('${avatarFallbackImage}') !important`
          }
        },
        // Size styles using ownerState
        ...(!ownerState.size || ownerState.size === "medium") && {
          width: theme2.spacing(4),
          height: theme2.spacing(4),
          ...theme2.typography.subtitle1
        },
        ...ownerState.size === "large" && {
          width: theme2.spacing(5),
          height: theme2.spacing(5),
          ...theme2.typography.h6
        },
        ...ownerState.size === "small" && {
          width: theme2.spacing(3),
          height: theme2.spacing(3),
          ...theme2.typography.caption,
          fontWeight: 500
        },
        ...ownerState.size === "xsmall" && {
          width: theme2.spacing(2.25),
          height: theme2.spacing(2.25),
          ...theme2.typography.caption,
          fontWeight: 500,
          svg: {
            width: ICON_SIZE_SMALL,
            height: ICON_SIZE_SMALL
          }
        },
        // Disabled styles
        ...ownerState.disabled && {
          opacity: 0.6
        }
      }),
      img: ({ theme: theme2 }) => ({
        boxShadow: `0 0 0 1px ${theme2.palette.default.outlinedBorder}`
      }),
      circular: () => ({
        borderRadius: avatarCircularRadius,
        "& img": {
          borderRadius: avatarCircularRadius
        }
      }),
      rounded: ({ theme: theme2 }) => ({
        borderRadius: theme2.spacing(avatarRoundedRadius),
        "& img": {
          borderRadius: theme2.spacing(avatarRoundedRadius)
        }
      })
    }
  },
  // Skeleton
  MuiSkeleton: {
    defaultProps: {
      animation: "wave"
    }
  },
  // Typography
  MuiTypography: {
    defaultProps: {
      color: "textPrimary",
      variantMapping: {
        caption: "p",
        overline: "p",
        overlineDelicate: "p"
      }
    }
  },
  // Svg Icons
  MuiSvgIcon: {
    styleOverrides: {
      root: () => ({
        fontSize: ICON_SIZE_MEDIUM
      }),
      fontSizeSmall: () => ({
        fontSize: ICON_SIZE_SMALL
      }),
      fontSizeLarge: () => ({
        fontSize: ICON_SIZE_LARGE
      })
    }
  }
};
const sizeXsmall = getSpacing(2);
const sizeSmall = getSpacing(3);
const sizeMedium = getSpacing(4);
const sizeLarge = getSpacing(6);
const radius = getSpacing(0.5);
const buttonsOverrides = {
  // Button Base
  MuiButtonBase: {
    defaultProps: {
      disableRipple: true
    },
    styleOverrides: {
      root: () => ({
        "& .MuiSvgIcon-root, & svg": {
          display: "flex",
          fontSize: ICON_SIZE_MEDIUM,
          width: ICON_SIZE_MEDIUM,
          minWidth: ICON_SIZE_MEDIUM,
          height: ICON_SIZE_MEDIUM
        }
      })
    }
  },
  // Button
  MuiButton: {
    defaultProps: {
      disableElevation: true
    },
    styleOverrides: {
      root: ({ ownerState, theme: theme2 }) => ({
        // maxWidth: '192px', TODO temporary disabled waiting for a design definition
        "&:hover, &:focus-visible": {
          boxShadow: theme2.shadows[0],
          ...ownerState.variant !== "contained" && {
            ...ownerState.color === "primary" && {
              backgroundColor: theme2.palette.primary.background
            },
            ...ownerState.color === "secondary" && {
              backgroundColor: theme2.palette.secondary.background
            },
            ...ownerState.color === "error" && {
              background: theme2.palette.error.relatedLight
            }
          },
          ...ownerState.variant === "contained" && ownerState.color === "secondary" && {
            backgroundColor: theme2.palette.secondary.light
          }
        },
        "& svg:not(.doNotFillIcon) path": {
          fill: "currentColor"
        },
        // Pairing buttons separation
        "& + .MuiButtonBase-root": {
          marginLeft: theme2.spacing(1)
        }
      }),
      contained: ({ theme: theme2 }) => ({
        boxShadow: "none",
        "&.Mui-disabled": {
          color: theme2.palette.text.disabled,
          backgroundColor: theme2.palette.action.disabledBackground
        }
      }),
      text: ({ theme: theme2 }) => ({
        minWidth: theme2.spacing(7)
      }),
      outlined: ({ theme: theme2 }) => ({
        "&.Mui-disabled": {
          color: theme2.palette.text.disabled,
          borderColor: theme2.palette.default.outlinedBorder
        }
      }),
      outlinedPrimary: ({ theme: theme2 }) => ({
        borderColor: theme2.palette.primary.main
      }),
      outlinedSecondary: ({ theme: theme2 }) => ({
        borderColor: theme2.palette.secondary.main
      }),
      outlinedError: ({ theme: theme2 }) => ({
        borderColor: theme2.palette.error.main
      }),
      containedPrimary: ({ theme: theme2 }) => ({
        "&:hover, &:focus-visible": {
          backgroundColor: theme2.palette.primary.dark
        }
      }),
      containedError: ({ theme: theme2 }) => ({
        "&:hover, &:focus-visible": {
          backgroundColor: theme2.palette.error.dark
        }
      }),
      startIcon: ({ theme: theme2 }) => ({
        marginRight: theme2.spacing(0.75),
        "& .MuiSvgIcon-root, & svg": {
          fontSize: ICON_SIZE_MEDIUM,
          width: ICON_SIZE_MEDIUM,
          minWidth: ICON_SIZE_MEDIUM,
          height: ICON_SIZE_MEDIUM
        },
        "&.MuiButton-iconSizeSmall": {
          marginRight: theme2.spacing(0.5),
          marginLeft: theme2.spacing(-0.5)
        }
      }),
      endIcon: ({ theme: theme2 }) => ({
        marginLeft: theme2.spacing(0.75),
        "& .MuiSvgIcon-root, & svg": {
          fontSize: ICON_SIZE_MEDIUM,
          width: ICON_SIZE_MEDIUM,
          minWidth: ICON_SIZE_MEDIUM,
          height: ICON_SIZE_MEDIUM
        },
        "&.MuiButton-iconSizeSmall": {
          marginLeft: theme2.spacing(0.5),
          marginRight: theme2.spacing(-0.5)
        }
      }),
      sizeSmall: ({ theme: theme2, ownerState }) => ({
        height: sizeSmall,
        padding: theme2.spacing(0, 1.5),
        ...theme2.typography.caption,
        lineHeight: sizeSmall,
        fontWeight: 500,
        letterSpacing: "0.4px",
        ...ownerState.variant === "text" && {
          padding: theme2.spacing(0, 1)
        }
      }),
      sizeMedium: ({ theme: theme2, ownerState }) => ({
        height: sizeMedium,
        padding: theme2.spacing(0, 2),
        lineHeight: sizeMedium,
        ...ownerState.variant === "text" && {
          padding: theme2.spacing(0, 1)
        }
      }),
      sizeLarge: ({ theme: theme2, ownerState }) => ({
        height: sizeLarge,
        padding: theme2.spacing(0, 2.5),
        ...theme2.typography.body1,
        lineHeight: sizeLarge,
        fontWeight: 500,
        letterSpacing: "0.25px",
        ...ownerState.variant === "text" && {
          padding: theme2.spacing(0, 2)
        }
      })
    },
    variants: [
      // Custom color and its variants
      {
        props: { variant: "contained", color: "default" },
        style: ({ theme: theme2 }) => ({
          color: theme2.palette.text.primary,
          backgroundColor: theme2.palette.default.main,
          borderColor: theme2.palette.text.primary,
          "&.Mui-disabled": {
            color: theme2.palette.text.disabled,
            backgroundColor: theme2.palette.action.disabledBackground
          },
          "&:hover, &:focus-visible": {
            backgroundColor: theme2.palette.default.dark
          }
        })
      },
      {
        props: { variant: "outlined", color: "default" },
        style: ({ theme: theme2 }) => ({
          color: theme2.palette.text.primary,
          borderColor: theme2.palette.text.primary,
          "&.Mui-disabled": {
            color: theme2.palette.text.disabled,
            borderColor: theme2.palette.default.outlinedBorder
          },
          "&:hover, &:focus-visible": {
            backgroundColor: theme2.palette.action.hover,
            borderColor: theme2.palette.text.primary
          }
        })
      },
      {
        props: { variant: "text", color: "default" },
        style: ({ theme: theme2 }) => ({
          color: theme2.palette.text.primary,
          "&.Mui-disabled": {
            color: theme2.palette.text.disabled
          },
          "&:hover, &:focus-visible": {
            backgroundColor: theme2.palette.action.hover
          }
        })
      }
    ]
  },
  // Mui Button Group
  MuiButtonGroup: {
    defaultProps: {
      disableRipple: true,
      disableElevation: true
    },
    styleOverrides: {
      root: ({ ownerState, theme: theme2 }) => ({
        "& .MuiButton-root + .MuiButton-root": {
          marginLeft: 0
        },
        ...ownerState.variant === "text" && {
          boxShadow: theme2.shadows[1],
          borderColor: theme2.palette.default.dark,
          "& .MuiButtonGroup-grouped:not(:last-of-type)": {
            borderColor: theme2.palette.default.dark
          }
        },
        ...ownerState.variant === "outlined" && {
          ...ownerState.color === "default" && {
            "& .MuiButtonBase-root.Mui-disabled": {
              borderColor: theme2.palette.text.primary
            }
          },
          ...ownerState.color === "primary" && {
            "& .MuiButtonBase-root.Mui-disabled": {
              borderColor: theme2.palette.primary.main
            }
          },
          ...ownerState.color === "secondary" && {
            "& .MuiButtonBase-root.Mui-disabled": {
              borderColor: theme2.palette.secondary.main
            }
          },
          ...ownerState.orientation !== "vertical" && {
            "& .MuiButtonGroup-grouped:not(:last-of-type):hover, & .Mui-disabled:not(:last-of-type)": {
              borderRightColor: "transparent"
            }
          }
        },
        ...ownerState.variant === "contained" && {
          ...ownerState.color === "default" && {
            "& .MuiButtonGroup-grouped:not(:last-of-type)": {
              borderRightColor: theme2.palette.default.dark,
              "&.Mui-disabled": {
                ...ownerState.color === "default" && {
                  borderColor: theme2.palette.default.dark
                }
              }
            }
          }
        }
      })
    }
  },
  // Icon Button
  MuiIconButton: {
    styleOverrides: {
      root: ({ ownerState, theme: theme2 }) => ({
        position: "relative",
        overflow: "hidden",
        borderRadius: theme2.spacing(0.5),
        ...ownerState.color === "default" && {
          color: theme2.palette.text.secondary
        },
        "& .MuiSvgIcon-root, & svg": {
          fontSize: ICON_SIZE_MEDIUM,
          width: ICON_SIZE_MEDIUM,
          minWidth: ICON_SIZE_MEDIUM,
          height: ICON_SIZE_MEDIUM
        },
        "& svg": {
          fill: "currentColor",
          "& path": {
            fillOpacity: 1
          }
        },
        "& svg:not(.doNotFillIcon) path": {
          fill: "currentColor"
        },
        "&.Mui-disabled svg:not(.doNotFillIcon) path": {
          fill: theme2.palette.text.disabled
        },
        "&:hover, &:focus-visible": {
          ...ownerState.color === "default" && {
            backgroundColor: theme2.palette.action.hover
          },
          ...ownerState.color === "primary" && {
            backgroundColor: theme2.palette.primary.background
          },
          ...ownerState.color === "secondary" && {
            backgroundColor: theme2.palette.secondary.background
          },
          ...ownerState.color === "error" && {
            backgroundColor: theme2.palette.error.relatedLight
          },
          ...ownerState.color === "warning" && {
            backgroundColor: theme2.palette.warning.relatedLight
          }
        }
      }),
      sizeSmall: () => ({
        width: sizeSmall,
        height: sizeSmall
      }),
      sizeMedium: () => ({
        width: sizeMedium,
        height: sizeMedium
      }),
      sizeLarge: () => ({
        width: sizeLarge,
        height: sizeLarge
      })
    },
    variants: [
      // Custom props and its variants
      {
        props: { size: "xsmall" },
        style: () => ({
          width: sizeXsmall,
          height: sizeXsmall,
          "& .MuiSvgIcon-root, & svg": {
            fontSize: ICON_SIZE_SMALL,
            width: ICON_SIZE_SMALL,
            minWidth: ICON_SIZE_SMALL,
            height: ICON_SIZE_SMALL
          }
        })
      },
      {
        props: { variant: "contained" },
        style: ({ theme: theme2 }) => ({
          // Default
          color: theme2.palette.text.primary,
          backgroundColor: theme2.palette.default.main,
          "&:hover": {
            backgroundColor: theme2.palette.default.dark
          },
          "&.MuiIconButton-colorSecondary": {
            color: theme2.palette.secondary.contrastText,
            backgroundColor: theme2.palette.secondary.main,
            "&:hover": {
              backgroundColor: theme2.palette.secondary.light
            }
          },
          "&.MuiIconButton-colorPrimary": {
            color: theme2.palette.primary.contrastText,
            backgroundColor: theme2.palette.primary.main,
            "&:hover": {
              backgroundColor: theme2.palette.primary.dark
            }
          },
          "&.MuiIconButton-colorError": {
            color: theme2.palette.error.contrastText,
            backgroundColor: theme2.palette.error.main,
            "&:hover": {
              backgroundColor: theme2.palette.error.dark
            }
          },
          "&.MuiIconButton-colorWarning": {
            color: theme2.palette.warning.contrastText,
            backgroundColor: theme2.palette.warning.main,
            "&:hover": {
              backgroundColor: theme2.palette.warning.light
            }
          },
          "&[disabled]": {
            color: theme2.palette.text.disabled,
            backgroundColor: theme2.palette.action.disabledBackground
          }
        })
      },
      {
        props: { variant: "outlined" },
        style: ({ theme: theme2 }) => ({
          // Default
          color: theme2.palette.text.primary,
          border: `1px solid ${theme2.palette.text.primary}`,
          "&:hover": {
            backgroundColor: theme2.palette.action.hover
          },
          "&.MuiIconButton-colorSecondary": {
            color: theme2.palette.secondary.main,
            borderColor: theme2.palette.secondary.main,
            "&:hover": {
              backgroundColor: theme2.palette.secondary.background
            }
          },
          "&.MuiIconButton-colorPrimary": {
            color: theme2.palette.primary.main,
            borderColor: theme2.palette.primary.main,
            "&:hover": {
              backgroundColor: theme2.palette.primary.background
            }
          },
          "&.MuiIconButton-colorError": {
            color: theme2.palette.error.main,
            borderColor: theme2.palette.error.main,
            "&:hover": {
              backgroundColor: theme2.palette.error.relatedLight
            }
          },
          "&.MuiIconButton-colorWarning": {
            color: theme2.palette.warning.main,
            borderColor: theme2.palette.warning.main,
            "&:hover": {
              backgroundColor: theme2.palette.warning.relatedLight
            }
          },
          "&[disabled]": {
            color: theme2.palette.text.disabled,
            borderColor: theme2.palette.default.outlinedBorder
          }
        })
      }
    ]
  },
  // MuiToggleButton
  MuiToggleButton: {
    styleOverrides: {
      root: ({ theme: theme2 }) => ({
        minWidth: sizeMedium,
        height: sizeMedium,
        padding: theme2.spacing(0, 1),
        color: theme2.palette.text.secondary,
        border: "none",
        borderRadius: radius,
        transition: "background-color 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
        "&:hover": {
          backgroundColor: theme2.palette.action.hover
        },
        // Pairing buttons separation
        "& + &": {
          marginLeft: theme2.spacing(0.5)
        },
        ".MuiSvgIcon-root, & svg": {
          margin: theme2.spacing(0, -0.75)
        },
        "&.Mui-selected": {
          color: theme2.palette.primary.main,
          backgroundColor: theme2.palette.primary.background,
          "&:hover": {
            backgroundColor: theme2.palette.action.hover
          }
        },
        "&.Mui-disabled": {
          border: "none"
        }
      }),
      sizeLarge: ({ theme: theme2 }) => ({
        minWidth: sizeLarge,
        height: sizeLarge,
        ...theme2.typography.body1
      }),
      sizeSmall: ({ theme: theme2 }) => ({
        minWidth: sizeSmall,
        height: sizeSmall,
        ...theme2.typography.caption,
        fontWeight: 500
      })
    }
  },
  // MuiToggleButtonGroup
  MuiToggleButtonGroup: {
    defaultProps: {
      orientation: "horizontal",
      exclusive: true
    },
    styleOverrides: {
      root: ({ theme: theme2, ownerState }) => ({
        alignItems: "center",
        justifyContent: "center",
        borderRadius: theme2.spacing(1),
        boxShadow: theme2.shadows[1],
        backgroundColor: theme2.palette.background.paper,
        "& .MuiToggleButtonGroup-grouped:not(:first-of-type), &.Mui-Selected, & .MuiToggleButtonGroup-grouped:not(:last-of-type)": {
          borderRadius: radius
        },
        ".MuiDivider-root": {
          "&.MuiDivider-vertical": {
            height: sizeLarge,
            margin: theme2.spacing(0, 1),
            marginLeft: theme2.spacing(0.5)
          },
          "&.MuiDivider-horizontal": {
            width: sizeLarge,
            margin: theme2.spacing(1, 0),
            marginTop: theme2.spacing(0.5)
          }
        },
        ".MuiToggleButton-sizeSmall": {
          "& + .MuiDivider-root.MuiDivider-vertical": {
            height: sizeMedium
          },
          "& + .MuiDivider-root.MuiDivider-horizontal": {
            width: sizeMedium
          }
        },
        // Variant: contained
        ...ownerState.variant === "contained" && {
          boxShadow: "none"
        },
        // Variant: unbounded
        ...ownerState.variant === "unbounded" && {
          boxShadow: "none",
          borderRadius: theme2.spacing(0.5),
          "& .MuiDivider-root": {
            height: theme2.spacing(4),
            "&.MuiToggleButtonGroup-groupedHorizontal": {
              height: theme2.spacing(4)
            },
            "&.MuiToggleButtonGroup-groupedVertical": {
              height: "auto",
              width: theme2.spacing(4),
              margin: `${theme2.spacing(0.5, 0, 1)} !important`,
              borderRadius: "0 !important"
            }
          },
          "& .MuiToggleButton-sizeSmall": {
            margin: 0,
            "&.MuiToggleButtonGroup-grouped:not(.MuiDivider-root)": {
              margin: 0
            },
            "& + .MuiDivider-root.MuiToggleButtonGroup-groupedHorizontal": {
              height: theme2.spacing(3)
            },
            "& + .MuiDivider-root.MuiToggleButtonGroup-groupedVertical": {
              height: "auto",
              width: theme2.spacing(3)
            }
          },
          ".MuiToggleButtonGroup-grouped:not(.MuiDivider-root)": {
            margin: 0,
            "&:first-of-type": {
              marginLeft: 0
            },
            "&:not(:last-of-type)": {
              marginRight: theme2.spacing(0.5)
            }
          },
          "&.MuiToggleButtonGroup-horizontal:not(.MuiDivider-root)": {
            ".MuiToggleButtonGroup-grouped": {
              margin: theme2.spacing(0, 0.5)
            }
          },
          "&.MuiToggleButtonGroup-vertical:not(.MuiDivider-root)": {
            ".MuiToggleButtonGroup-grouped": {
              margin: theme2.spacing(0, 0, 0.5),
              "&:not(:last-of-type)": {
                marginRight: 0
              },
              "&:last-of-type": {
                marginBottom: 0
              }
            }
          }
        },
        // Background colors using data-attribute selector
        '&[data-background-color="primary"]': {
          backgroundColor: theme2.palette.background.paper
        },
        '&[data-background-color="secondary"]': {
          backgroundColor: theme2.palette.background.default
        },
        '&[data-background-color="transparent"]': {
          backgroundColor: "transparent"
        }
      }),
      // Styles applied to the children if orientation="horizontal"
      groupedHorizontal: ({ theme: theme2 }) => ({
        height: sizeMedium,
        margin: theme2.spacing(1),
        "&:not(:last-of-type)": {
          marginRight: theme2.spacing(0.5),
          marginLeft: 0,
          borderLeft: "none"
        },
        "&:first-of-type:not(.MuiDivider-root)": {
          marginLeft: theme2.spacing(1)
        },
        "&:last-of-type:not(.MuiDivider-root)": {
          marginLeft: 0
        },
        "&.MuiToggleButton-sizeSmall:not(.MuiDivider-root)": {
          height: sizeSmall,
          margin: theme2.spacing(0.5),
          "&:not(:first-of-type)": {
            marginLeft: 0
          }
        }
      }),
      // Styles applied to the children if orientation="vertical"
      groupedVertical: ({ theme: theme2 }) => ({
        width: sizeMedium,
        margin: theme2.spacing(1),
        "&.MuiToggleButton-root": {
          marginLeft: theme2.spacing(1),
          marginBottom: theme2.spacing(0.5),
          "&:last-of-type": {
            marginBottom: theme2.spacing(1)
          },
          "&:not(:first-of-type)": {
            marginTop: 0
          }
        },
        "&.MuiToggleButton-sizeSmall": {
          width: sizeSmall,
          margin: theme2.spacing(0.5),
          "&:last-of-type": {
            marginBottom: theme2.spacing(0.5)
          }
        }
      })
    }
  },
  // FAB button
  MuiFab: {
    defaultProps: {
      color: "primary"
    },
    styleOverrides: {
      root: ({ ownerState, theme: theme2 }) => ({
        "&:focus": {
          boxShadow: theme2.shadows[6]
        },
        "& .MuiSvgIcon-root, & svg": {
          fontSize: ICON_SIZE_LARGE,
          width: ICON_SIZE_LARGE,
          minWidth: ICON_SIZE_LARGE,
          height: ICON_SIZE_LARGE
        },
        "&.MuiFab-extended": {
          ...theme2.typography.body1,
          fontWeight: 500,
          width: "auto",
          height: theme2.spacing(7),
          paddingRight: theme2.spacing(3),
          borderRadius: theme2.spacing(8),
          "& .MuiSvgIcon-root": {
            marginRight: theme2.spacing(1.5)
          }
        },
        ...ownerState.color === "default" && {
          color: theme2.palette.text.primary,
          backgroundColor: theme2.palette.background.paper,
          "&:hover, &:focus-visible": {
            backgroundColor: theme2.palette.default.light
          }
        }
      }),
      sizeSmall: ({ theme: theme2 }) => ({
        width: theme2.spacing(4),
        height: theme2.spacing(4),
        minHeight: theme2.spacing(4),
        "& .MuiSvgIcon-root, & svg": {
          fontSize: ICON_SIZE_MEDIUM,
          width: ICON_SIZE_MEDIUM,
          minWidth: ICON_SIZE_MEDIUM,
          height: ICON_SIZE_MEDIUM
        },
        "&.MuiFab-extended": {
          ...theme2.typography.caption,
          width: "auto",
          height: theme2.spacing(4),
          paddingRight: theme2.spacing(2),
          "& .MuiSvgIcon-root": {
            marginRight: theme2.spacing(1)
          }
        }
      }),
      sizeMedium: ({ theme: theme2 }) => ({
        "&.MuiFab-extended": {
          ...theme2.typography.button,
          height: theme2.spacing(6)
        }
      }),
      secondary: ({ theme: theme2 }) => ({
        "&:hover": {
          backgroundColor: theme2.palette.secondary.light
        }
      })
    }
  }
};
const controlSizeS = 2.25;
const controlSizeM = 3;
const switchSizeS = 2;
const switchSizeM = 3;
const switchSizeL = 4;
const checkboxRadioOverrides = {
  root: ({ ownerState, theme: theme2 }) => ({
    padding: theme2.spacing(0.5),
    ...ownerState.size === "small" && {
      padding: "3px"
      // Forced to a non-standard value to meet with design
    },
    ...ownerState.readOnly === true && {
      pointerEvents: "none",
      color: theme2.palette.text.disabled,
      "&.Mui-checked": {
        color: theme2.palette.text.disabled
      }
    },
    "&:hover, &:focus-visible": {
      backgroundColor: theme2.palette.primary.background
    },
    "& + .MuiFormControlLabel-label": {
      ...theme2.typography.body2,
      marginLeft: theme2.spacing(0.25),
      ...ownerState.size === "small" && {
        marginLeft: theme2.spacing(0.5)
      }
    },
    "& .MuiSvgIcon-root": {
      fontSize: theme2.spacing(controlSizeM),
      width: theme2.spacing(controlSizeM),
      minWidth: theme2.spacing(controlSizeM),
      height: theme2.spacing(controlSizeM),
      ...ownerState.size === "small" && {
        fontSize: theme2.spacing(controlSizeS),
        width: theme2.spacing(controlSizeS),
        minWidth: theme2.spacing(controlSizeS),
        height: theme2.spacing(controlSizeS)
      }
    }
  })
};
const LabelOverrides = {
  root: ({ theme: theme2 }) => ({
    position: "static",
    transform: "none",
    marginBottom: theme2.spacing(1),
    ...theme2.typography.caption,
    fontWeight: 500,
    color: theme2.palette.text.primary
  }),
  sizeSmall: ({ theme: theme2 }) => ({
    marginBottom: theme2.spacing(0.5)
  }),
  standard: () => ({
    marginBottom: 0
  }),
  // Temporal workaroud to give a faster solution for a Workflows demand: https://app.shortcut.com/cartoteam/story/294539/distinction-among-parameters-optional-inputs-units-in-the-ui
  // These styles avoid (by now) the need to review current forms and change those with a required mark.
  // TODO: remored asterisk completely and use instead LabelWithIndicator component to mark also required ones.
  asterisk: ({ theme: theme2 }) => ({
    "&, &.Mui-error": {
      color: "transparent"
    },
    "&::after": {
      content: '"(required)"',
      marginLeft: theme2.spacing(-0.5),
      color: theme2.palette.text.secondary,
      fontWeight: 400,
      ".Mui-disabled &": {
        color: theme2.palette.text.disabled
      }
    }
  })
};
const formsOverrides = {
  // Checkbox
  MuiCheckbox: {
    defaultProps: {
      size: "small"
    },
    styleOverrides: {
      ...checkboxRadioOverrides
    }
  },
  // Radio Button
  MuiRadio: {
    defaultProps: {
      size: "small"
    },
    styleOverrides: {
      ...checkboxRadioOverrides
    }
  },
  // Text Field
  MuiTextField: {
    defaultProps: {
      fullWidth: true,
      size: "small",
      InputLabelProps: {
        shrink: true
      },
      SelectProps: {
        IconComponent: ArrowDown,
        size: "small"
      }
    },
    styleOverrides: {
      root: ({ ownerState, theme: theme2 }) => ({
        "& legend": {
          display: "none"
        },
        // Select bool
        ...ownerState.select === true && {
          "& .MuiInputBase-root": {
            padding: 0,
            "&.MuiOutlinedInput-root, &.MuiFilledInput-root": {
              padding: 0
            },
            "& .MuiInputAdornment-positionEnd": {
              marginRight: theme2.spacing(3)
            },
            "& .MuiSelect-select": {
              padding: theme2.spacing(1.5),
              "&.MuiInputBase-input": {
                paddingLeft: theme2.spacing(2),
                paddingRight: theme2.spacing(5),
                "&.MuiSelect-standard": {
                  paddingLeft: 0
                }
              },
              "&:focus": {
                background: "transparent"
              },
              "& .MuiTypography-root": {
                ...ellipsisStyles
              }
            },
            "& .MuiSelect-icon": {
              right: theme2.spacing(2),
              color: theme2.palette.text.secondary
            },
            "& .MuiSelect-iconStandard": {
              right: 0
            }
          },
          "& .MuiInputBase-sizeSmall": {
            "&.MuiInputBase-root.MuiFilledInput-root": {
              padding: 0
            },
            "& .MuiSelect-select": {
              ...theme2.typography.body2,
              padding: theme2.spacing(0.75),
              "&.MuiInputBase-input": {
                paddingLeft: theme2.spacing(1.5),
                paddingRight: theme2.spacing(4)
              }
            },
            "&.MuiOutlinedInput-root.MuiInputBase-sizeSmall": {
              padding: 0
            },
            "& .MuiSelect-icon": {
              right: theme2.spacing(1.5)
            }
          }
        }
      })
    }
  },
  // Input Base
  MuiInputBase: {
    styleOverrides: {
      root: ({ theme: theme2 }) => ({
        height: theme2.spacing(6),
        ...theme2.typography.body1,
        "& input": {
          padding: 0,
          ...ellipsisStyles,
          "&::placeholder": {
            opacity: 1,
            color: theme2.palette.text.hint
          },
          "&:read-only::placeholder": {
            color: theme2.palette.text.disabled
          },
          "&.Mui-disabled::placeholder": {
            color: theme2.palette.text.disabled
          },
          // Remove focus on keyboard navigation as the parent element has focus
          "&:focus-visible": {
            outline: "none !important",
            boxShadow: "none !important"
          }
        },
        "&.Mui-disabled": {
          cursor: "not-allowed",
          "& .Mui-disabled": {
            cursor: "not-allowed"
          }
        },
        "&.MuiInputBase-formControl::after": {
          top: 0,
          transform: "none",
          opacity: 0
        },
        "&.MuiInputBase-formControl.Mui-focused::after": {
          transform: "none",
          opacity: 1
        },
        "& legend": { display: "none" },
        "& .MuiButtonBase-root.MuiMenuItem-root": {
          padding: 0,
          "&:hover": {
            backgroundColor: "transparent"
          },
          [theme2.breakpoints.up("sm")]: {
            minHeight: "initial"
          }
        },
        // Variants
        "&.MuiFilledInput-root": {
          padding: theme2.spacing(1, 2),
          borderRadius: theme2.spacing(0.5),
          backgroundColor: theme2.palette.default.background,
          "&:hover": {
            backgroundColor: theme2.palette.default.background
          },
          "&::before": {
            top: 0,
            borderRadius: theme2.spacing(0.5),
            border: "1px solid transparent",
            transition: "border 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms"
          },
          "&:hover:not(.Mui-disabled)::before": {
            borderColor: theme2.palette.text.primary
          },
          "&::after": {
            borderRadius: theme2.spacing(0.5),
            border: "1px solid transparent"
          },
          "&.MuiInputBase-sizeSmall": {
            padding: theme2.spacing(0.5, 1.5)
          },
          "&.Mui-focused": {
            backgroundColor: theme2.palette.background.paper,
            "&::after": {
              border: `2px solid ${theme2.palette.primary.main}`
            }
          },
          "&.Mui-disabled": {
            backgroundColor: theme2.palette.default.background,
            "&::before": {
              borderBottomStyle: "solid"
            }
          },
          "&.Mui-error::after": {
            opacity: 1,
            border: `2px solid ${theme2.palette.error.light}`
          },
          "&.Mui-readOnly": {
            "&.Mui-focused": {
              backgroundColor: theme2.palette.default.background
            }
          }
        },
        "&.MuiOutlinedInput-root": {
          padding: theme2.spacing(1, 2),
          "&.MuiInputBase-sizeSmall": {
            padding: theme2.spacing(0.5, 1.5)
          },
          "&.Mui-focused": {
            backgroundColor: theme2.palette.background.paper
          },
          "&.Mui-disabled": {
            backgroundColor: theme2.palette.default.background
          },
          "&.Mui-readOnly": {
            backgroundColor: theme2.palette.default.background,
            "&.Mui-focused": {
              backgroundColor: theme2.palette.default.background
            }
          },
          "& .MuiOutlinedInput-notchedOutline": {
            top: 0,
            borderColor: theme2.palette.default.outlinedBorder,
            transition: "border 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms"
          },
          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
            transition: "none"
          },
          "&.Mui-error .MuiOutlinedInput-notchedOutline": {
            border: `2px solid ${theme2.palette.error.light}`
          }
        },
        "&.MuiInput-underline": {
          marginTop: 0,
          padding: 0,
          "&::before": {
            borderColor: theme2.palette.default.outlinedBorder
          },
          "&:hover:not(.Mui-disabled)::before": {
            borderBottom: `1px solid ${theme2.palette.text.primary}`
          },
          "&:not(.Mui-disabled)::after": {
            borderBottom: "1px solid transparent"
          },
          "&.Mui-focused::after": {
            borderBottom: `2px solid ${theme2.palette.primary.main}`
          },
          "&.Mui-error::after": {
            opacity: 1,
            borderBottom: `2px solid ${theme2.palette.error.light}`
          },
          "&.Mui-disabled::before": {
            borderBottomStyle: "solid"
          }
        },
        // TextArea (multiline)
        "&.MuiInputBase-multiline": {
          height: "auto",
          minHeight: theme2.spacing(12),
          alignItems: "flex-start",
          padding: theme2.spacing(0, 0.25),
          "& textarea": {
            padding: theme2.spacing(1.5, 1.75),
            ...theme2.typography.body1,
            "&::placeholder": {
              opacity: 1,
              color: theme2.palette.text.hint
            },
            "&.Mui-disabled::placeholder": {
              color: theme2.palette.text.disabled
            },
            // Remove focus on keyboard navigation as the parent element has focus
            "&:focus-visible": {
              outline: "none !important",
              boxShadow: "none !important"
            }
          },
          "&.MuiInputBase-sizeSmall": {
            minHeight: theme2.spacing(9),
            padding: theme2.spacing(0, 0.25),
            "& textarea": {
              padding: theme2.spacing(1, 1.25),
              ...theme2.typography.body2
            }
          }
        },
        // Select Multiple selection
        "&.MuiInputBase-root .MuiSelect-multiple.MuiInputBase-input": {
          paddingLeft: 0,
          paddingRight: theme2.spacing(3)
        }
      }),
      // size
      sizeSmall: ({ theme: theme2 }) => ({
        height: theme2.spacing(4),
        padding: theme2.spacing(0, 1.5),
        "& input": {
          ...theme2.typography.body2
        }
      })
    }
  },
  // Input Adornment
  MuiInputAdornment: {
    styleOverrides: {
      root: ({ theme: theme2 }) => ({
        "& .MuiTypography-root": {
          ...theme2.typography.body1,
          color: theme2.palette.text.secondary
        },
        "&.MuiInputAdornment-sizeSmall": {
          "& .MuiTypography-root": {
            ...theme2.typography.body2
          }
        },
        "&.MuiInputAdornment-positionStart.MuiInputAdornment-root:not(.MuiInputAdornment-hiddenLabel)": {
          marginTop: 0
        },
        "& .MuiSvgIcon-root, & svg": {
          fontSize: ICON_SIZE_MEDIUM,
          width: ICON_SIZE_MEDIUM,
          minWidth: ICON_SIZE_MEDIUM,
          height: ICON_SIZE_MEDIUM,
          color: theme2.palette.text.secondary
        },
        ".Mui-disabled &": {
          "& .MuiTypography-root, & .MuiSvgIcon-root": {
            color: theme2.palette.text.disabled
          }
        }
      })
    }
  },
  // Form Control
  MuiFormControl: {
    defaultProps: {
      fullWidth: true
    }
  },
  // Form Control Label (radio, checkbox and switch wrapper)
  MuiFormControlLabel: {
    styleOverrides: {
      root: ({ ownerState, theme: theme2 }) => ({
        marginLeft: theme2.spacing(-0.5),
        "& .MuiSwitch-root": {
          marginLeft: theme2.spacing(0.5)
        },
        ...ownerState.readOnly === true && {
          pointerEvents: "none"
        }
      })
    }
  },
  // Form Helper Text
  MuiFormHelperText: {
    styleOverrides: {
      root: ({ theme: theme2 }) => ({
        margin: 0,
        marginTop: theme2.spacing(1)
      })
    }
  },
  // Label
  MuiInputLabel: {
    styleOverrides: {
      ...LabelOverrides
    }
  },
  MuiFormLabel: {
    styleOverrides: {
      ...LabelOverrides
    }
  },
  // Select
  MuiSelect: {
    defaultProps: {
      IconComponent: ArrowDown,
      fullWidth: true,
      size: "small"
    },
    styleOverrides: {
      root: ({ theme: theme2 }) => ({
        padding: 0,
        "& .MuiSelect-icon": {
          right: theme2.spacing(2),
          color: theme2.palette.text.secondary
        },
        "&.Mui-disabled .MuiSelect-icon, &.Mui-readOnly .MuiSelect-icon": {
          color: theme2.palette.text.disabled
        },
        "& .MuiSelect-iconStandard": {
          right: 0
        },
        "& legend": {
          display: "none"
        },
        // Variants
        "&.MuiOutlinedInput-root, &.MuiFilledInput-root": {
          padding: 0
        },
        "&.MuiFilledInput-root, &.MuiInput-underline": {
          "&.Mui-focused::after": {
            height: "100%",
            transition: "none"
          }
        },
        // Size Small
        "&.MuiInputBase-sizeSmall": {
          ...theme2.typography.body2,
          "& .MuiSelect-select": {
            "&.MuiInputBase-input": {
              paddingLeft: theme2.spacing(1.5),
              paddingRight: theme2.spacing(4)
            },
            "&.MuiSelect-standard": {
              paddingLeft: 0
            }
          },
          "&.MuiOutlinedInput-root.MuiInputBase-sizeSmall, &.MuiFilledInput-root.MuiInputBase-sizeSmall": {
            padding: 0
          },
          "& .MuiSelect-icon": {
            right: theme2.spacing(1.5)
          }
        }
      }),
      select: ({ theme: theme2 }) => ({
        padding: theme2.spacing(1.5),
        "&.MuiInputBase-input": {
          paddingLeft: theme2.spacing(2),
          paddingRight: theme2.spacing(5),
          "&.MuiSelect-standard": {
            paddingLeft: 0
          }
        },
        "&:focus": {
          background: "transparent"
        },
        // Remove focus on keyboard navigation as the parent element has focus
        "&:focus-visible": {
          outline: "none !important",
          boxShadow: "none !important"
        },
        "& .MuiTypography-root": {
          ...ellipsisStyles
        },
        "&.MuiInputBase-inputSizeSmall": {
          padding: theme2.spacing(0.75)
        }
      })
    }
  },
  // Autocomplete
  MuiAutocomplete: {
    defaultProps: {
      size: "small",
      fullWidth: true,
      popupIcon: /* @__PURE__ */ jsx(ArrowDown, {}),
      clearIcon: /* @__PURE__ */ jsx(Tooltip, { title: "Clear", children: /* @__PURE__ */ jsx(Cancel, { "data-testid": "cancel-icon-autocomplete" }) }),
      clearText: "",
      ChipProps: { color: "default" },
      limitTags: 1,
      componentsProps: {
        paper: {
          elevation: 8
        }
      }
    },
    styleOverrides: {
      root: ({ ownerState, theme: theme2 }) => ({
        "&.MuiAutocomplete-root .MuiFormControl-root": {
          //Needed to overide Mui default styles
          ".MuiInputBase-root": {
            gap: theme2.spacing(0.5),
            height: "auto",
            minHeight: theme2.spacing(6),
            padding: theme2.spacing(1, 2),
            paddingRight: theme2.spacing(5),
            ".MuiInputBase-input": {
              padding: 0
            },
            // Multiple
            ...ownerState.multiple === true && {
              paddingLeft: theme2.spacing(1),
              ".MuiInputBase-input": {
                padding: 0,
                marginLeft: theme2.spacing(1)
              }
            },
            ...ownerState.size === "small" && {
              minHeight: theme2.spacing(4),
              padding: theme2.spacing(0.5, 1.5),
              paddingRight: theme2.spacing(4),
              ...ownerState.multiple === true && {
                paddingLeft: theme2.spacing(0.5)
              }
            },
            ...ownerState.readOnly === true && {
              backgroundColor: theme2.palette.default.background
            },
            "&.Mui-disabled": {
              pointerEvents: "none"
            }
          },
          // Variants
          ".MuiFilledInput-root .MuiAutocomplete-tag": {
            backgroundColor: "transparent",
            border: `1px solid ${theme2.palette.default.main}`
          }
        },
        "&.MuiAutocomplete-hasClearIcon .MuiFormControl-root .MuiInputBase-root": {
          paddingRight: theme2.spacing(8.5),
          ...ownerState.size === "small" && {
            paddingRight: theme2.spacing(7)
          }
        }
      }),
      inputRoot: ({ theme: theme2 }) => ({
        maxHeight: theme2.spacing(20),
        // 160px
        overflow: "auto",
        transition: "box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
        "& .MuiAutocomplete-input": {
          minWidth: `${theme2.spacing(10)} !important`,
          "&[readOnly]": {
            display: "none"
          }
        },
        // Overrides in variants needed to allow scrollbar to appear correctly at max height
        "&::before, &::after": {
          content: "none"
        },
        "& fieldset": {
          border: "0 !important"
        },
        "&.MuiOutlinedInput-root": {
          boxShadow: `inset 0 0 0 1px ${theme2.palette.default.outlinedBorder}`
        },
        "&:hover": {
          boxShadow: `inset 0 0 0 1px ${theme2.palette.text.primary}`
        },
        "&.Mui-focused": {
          transition: "none",
          boxShadow: `inset 0 0 0 2px ${theme2.palette.primary.main}`
        },
        "&.Mui-error": {
          boxShadow: `inset 0 0 0 2px ${theme2.palette.error.light}`
        },
        "&.Mui-disabled.MuiOutlinedInput-root": {
          boxShadow: `inset 0 0 0 1px ${theme2.palette.default.outlinedBorder}`,
          "&.Mui-error": {
            boxShadow: `inset 0 0 0 2px ${theme2.palette.error.light}`
          }
        },
        "&.Mui-disabled.MuiFilledInput-root": {
          "& .MuiAutocomplete-tag": {
            borderColor: `${theme2.palette.default.outlinedBorder} !important`
          }
        }
      }),
      endAdornment: ({ theme: theme2 }) => ({
        transform: "none",
        top: theme2.spacing(2),
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-end",
        marginRight: theme2.spacing(1),
        ".MuiAutocomplete-hasClearIcon &": {
          top: theme2.spacing(1)
        },
        ".MuiInputBase-sizeSmall &": {
          top: theme2.spacing(0.5),
          width: theme2.spacing(3),
          height: theme2.spacing(3),
          marginRight: theme2.spacing(0.5)
        }
      }),
      clearIndicator: ({ ownerState, theme: theme2 }) => ({
        marginRight: 0,
        color: theme2.palette.text.hint,
        ...ownerState.size === "small" && {
          width: theme2.spacing(3),
          height: theme2.spacing(3)
        }
      }),
      popupIndicator: ({ theme: theme2 }) => ({
        width: ICON_SIZE_MEDIUM,
        height: ICON_SIZE_MEDIUM,
        cursor: "pointer",
        "&:hover": {
          backgroundColor: "transparent"
        },
        "&.MuiButtonBase-root": {
          color: theme2.palette.text.secondary
        },
        ".Mui-disabled &": {
          color: theme2.palette.text.disabled
        },
        "input:read-only + .MuiAutocomplete-endAdornment &": {
          color: theme2.palette.text.disabled
        }
      }),
      tag: ({ ownerState, theme: theme2 }) => ({
        margin: 0,
        "&:not(.MuiButtonBase-root)": {
          display: "flex",
          alignItems: "center",
          height: theme2.spacing(4),
          padding: theme2.spacing(0, 1.5),
          backgroundColor: theme2.palette.default.main,
          borderRadius: theme2.spacing(2),
          ...theme2.typography.button,
          fontWeight: theme2.typography.fontWeightMedium,
          ...ownerState.size === "small" && {
            height: theme2.spacing(3),
            padding: theme2.spacing(0, 1),
            borderRadius: theme2.spacing(1.5),
            ...theme2.typography.caption,
            fontWeight: theme2.typography.fontWeightMedium
          }
        }
      }),
      option: ({ ownerState, theme: theme2 }) => ({
        "&.MuiAutocomplete-option": {
          minHeight: MENU_ITEM_SIZE_DEFAULT,
          padding: theme2.spacing(0.5, 2),
          ...theme2.typography.body2,
          transition: "background-color 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
          "& .MuiCheckbox-root svg path": {
            fill: theme2.palette.text.secondary
          },
          "&:hover": {
            backgroundColor: theme2.palette.action.hover
          },
          "&.Mui-disabled": {
            "& .MuiCheckbox-root svg path": {
              fill: theme2.palette.text.disabled
            }
          },
          '&[aria-disabled="true"]': {
            opacity: 1
          },
          '&[aria-selected="true"]': {
            color: theme2.palette.primary.main,
            backgroundColor: theme2.palette.primary.background,
            ".MuiTypography-root": {
              color: theme2.palette.primary.main
            },
            ".MuiTypography-caption": {
              color: theme2.palette.text.secondary
            },
            "& .MuiCheckbox-root svg path": {
              fill: theme2.palette.primary.main
            },
            "&.Mui-focused:hover": {
              backgroundColor: theme2.palette.action.hover
            },
            "&.Mui-disabled": {
              backgroundColor: "transparent",
              "& svg path": {
                fill: theme2.palette.text.disabled
              },
              "& .MuiCheckbox-root svg path": {
                fill: theme2.palette.text.disabled
              },
              "& .MuiTypography-root": {
                color: theme2.palette.text.disabled
              }
            }
          },
          "&:first-of-type": {
            marginTop: theme2.spacing(1)
          },
          ...ownerState.size === "small" && {
            padding: theme2.spacing(0.5, 1.5)
          }
        }
      }),
      noOptions: ({ ownerState, theme: theme2 }) => ({
        padding: theme2.spacing(2.5, 2),
        ...theme2.typography.body2,
        color: theme2.palette.text.secondary,
        ...ownerState.size === "small" && {
          padding: theme2.spacing(2, 1.5)
        }
      }),
      listbox: ({ theme: theme2 }) => ({
        paddingTop: 0,
        ".MuiDivider-root": {
          display: "none"
        },
        ".MuiButtonBase-root + .MuiDivider-root": {
          display: "block"
        },
        ".MuiMenuItem-root:first-of-type": {
          marginTop: theme2.spacing(1)
        }
      })
    }
  },
  // Switch
  MuiSwitch: {
    defaultProps: {
      disableRipple: true
    },
    styleOverrides: {
      root: ({ theme: theme2 }) => ({
        width: theme2.spacing(switchSizeM),
        height: theme2.spacing(switchSizeS),
        padding: 0,
        overflow: "visible",
        "& + .MuiTypography-root": {
          marginLeft: theme2.spacing(1),
          color: theme2.palette.text.primary
        },
        "& + .MuiFormControlLabel-label": {
          ...theme2.typography.body2
        }
      }),
      switchBase: ({ ownerState, theme: theme2 }) => ({
        width: theme2.spacing(switchSizeL),
        height: theme2.spacing(switchSizeL),
        padding: theme2.spacing(0.5),
        borderRadius: "50%",
        color: theme2.palette.text.secondary,
        transform: "translate(-8px, -8px)",
        "&:hover": {
          backgroundColor: theme2.palette.action.hover
        },
        "&.MuiSwitch-switchBase input": {
          top: theme2.spacing(1),
          left: theme2.spacing(1)
        },
        "&.Mui-checked": {
          transform: "translate(0, -8px)",
          color: theme2.palette.common.white,
          "&.MuiSwitch-switchBase input": {
            left: 0
          },
          "& + .MuiSwitch-track": {
            opacity: 1,
            border: 0
          }
        },
        ...ownerState.readOnly === true && {
          color: theme2.palette.text.disabled
        }
      }),
      thumb: ({ theme: theme2 }) => ({
        width: theme2.spacing(1),
        height: theme2.spacing(1),
        boxShadow: theme2.shadows[0],
        ".Mui-checked &": {
          boxShadow: theme2.shadows[1]
        },
        ".Mui-disabled &": {
          backgroundColor: theme2.palette.text.disabled
        },
        ".Mui-disabled.Mui-checked &": {
          backgroundColor: theme2.palette.common.white
        }
      }),
      input: ({ theme: theme2 }) => ({
        width: theme2.spacing(switchSizeM),
        height: theme2.spacing(switchSizeS),
        left: 0
      }),
      track: ({ ownerState, theme: theme2 }) => ({
        height: "auto",
        border: `1px solid ${theme2.palette.text.secondary}`,
        borderRadius: theme2.spacing(2),
        opacity: 1,
        backgroundColor: theme2.palette.common.white,
        transitionDuration: "300ms",
        ".MuiButtonBase-root.MuiSwitch-switchBase.Mui-disabled + &": {
          opacity: 1,
          borderColor: theme2.palette.text.disabled
        },
        ".MuiButtonBase-root.Mui-checked.Mui-disabled + &": {
          backgroundColor: theme2.palette.text.disabled
        },
        ".MuiButtonBase-root.MuiSwitch-switchBase[readOnly] + &": {
          borderColor: theme2.palette.text.disabled
        },
        "[readOnly] .MuiButtonBase-root.Mui-checked + &": {
          backgroundColor: theme2.palette.text.disabled
        },
        ...ownerState.readOnly === true && {
          borderColor: theme2.palette.text.disabled
        }
      }),
      colorPrimary: ({ theme: theme2 }) => ({
        "&.Mui-checked:hover": {
          backgroundColor: theme2.palette.primary.background
        }
      }),
      colorSecondary: ({ theme: theme2 }) => ({
        "&.Mui-checked:hover": {
          backgroundColor: theme2.palette.secondary.background
        }
      })
    }
  },
  // Circular Progress
  MuiCircularProgress: {
    defaultProps: {
      size: 40,
      thickness: 4
    },
    styleOverrides: {
      root: ({ theme: theme2 }) => ({
        // Not using standard ownerState to avoid MUI error trying to access non-existent theme.palette.neutral.main
        '&[data-color="neutral"]': {
          color: theme2.palette.text.hint
        }
      })
    }
  },
  // Slider
  MuiSlider: {
    defaultProps: {
      color: "primary",
      marks: false,
      size: "small"
    },
    styleOverrides: {
      thumb: ({ theme: theme2 }) => ({
        "&:hover, &.Mui-focusVisible": {
          boxShadow: `0 0 0 ${theme2.spacing(1)} ${theme2.palette.primary.background}`
        }
      })
    }
  }
};
const navigationOverrides = {
  // Menu
  MuiMenu: {
    styleOverrides: {
      paper: ({ theme: theme2 }) => ({
        "&.MuiMenu-paper": {
          minWidth: theme2.spacing(8),
          // 64px, defined by design
          maxHeight: MENU_LIST_MAX_SIZE,
          // 312px, defined by design
          "&:focus-visible": {
            outline: "none !important",
            boxShadow: "none !important"
          }
        }
      })
    }
  },
  // Menu Item
  MuiMenuItem: {
    styleOverrides: {
      root: ({ theme: theme2 }) => ({
        ...theme2.typography.body2,
        columnGap: theme2.spacing(1),
        minHeight: MENU_ITEM_SIZE_DEFAULT,
        padding: theme2.spacing(0.75, 0),
        whiteSpace: "normal",
        transition: "background-color 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
        "&.MuiMenuItem-gutters": {
          padding: theme2.spacing(0.75, 1, 0.75, 1.5)
        },
        [theme2.breakpoints.up("sm")]: {
          // Overrides an unwanted Mui default style
          "&.MuiButtonBase-root": {
            minHeight: MENU_ITEM_SIZE_DEFAULT
          }
        },
        "&:hover": {
          ".MuiAvatar-root, .MuiChip-root, .CartoTag-root": {
            cursor: "pointer"
          }
        },
        "&:focus-visible": {
          // Solves a known Mui issue: https://github.com/mui/material-ui/issues/23747
          backgroundColor: "transparent",
          outline: `none !important`,
          boxShadow: `inset 0 0 0 2px ${theme2.palette.primary.main} !important`,
          borderRadius: theme2.shape.borderRadius,
          "&:hover": {
            backgroundColor: theme2.palette.action.hover
          }
        },
        "&.Mui-selected": {
          color: theme2.palette.primary.main,
          "&:focus-visible": {
            // Solves a known Mui issue: https://github.com/mui/material-ui/issues/23747
            backgroundColor: theme2.palette.primary.background
          },
          "&:hover": {
            backgroundColor: theme2.palette.action.hover
          },
          "& .MuiTypography-root, & .MuiSvgIcon-root": {
            color: theme2.palette.primary.main
          },
          ".MuiTypography-caption": {
            // secondary text
            color: theme2.palette.text.secondary
          }
        },
        "&.Mui-disabled": {
          opacity: 1,
          color: theme2.palette.text.disabled,
          backgroundColor: theme2.palette.background.paper,
          "&:empty": {
            height: 0,
            minHeight: 0,
            padding: 0
          },
          ".MuiTypography-root": {
            color: theme2.palette.text.disabled
          },
          svg: {
            color: theme2.palette.text.disabled
          },
          ".MuiListItemIcon-root svg path": {
            fill: theme2.palette.text.disabled
          },
          ".MuiAvatar-root": {
            color: theme2.palette.text.disabled,
            backgroundColor: theme2.palette.action.disabledBackground
          }
        },
        "& > .MuiSvgIcon-root": {
          marginRight: theme2.spacing(1)
        },
        ".MuiMenu-paper-sizeSmall &": {
          paddingLeft: theme2.spacing(1.5),
          paddingRight: theme2.spacing(1.5)
        }
      }),
      dense: ({ theme: theme2 }) => ({
        minHeight: MENU_ITEM_SIZE_DENSE,
        paddingTop: 0,
        paddingBottom: 0,
        ".MuiTypography-root": {
          ...theme2.typography.caption,
          fontWeight: 500
        },
        [theme2.breakpoints.up("sm")]: {
          // Overrides an unwanted Mui default style
          "&.MuiButtonBase-root": {
            minHeight: MENU_ITEM_SIZE_DENSE
          }
        }
      })
    }
  },
  // List
  MuiList: {
    styleOverrides: {
      root: ({ theme: theme2 }) => ({
        paddingTop: 0,
        ".MuiPopover-root &, .MuiPopper-root &, .base-Popper-root &": {
          minWidth: theme2.spacing(8),
          // 64px, defined by design
          maxHeight: MENU_LIST_MAX_SIZE,
          // 312px, defined by design
          overflowY: "auto",
          "&:focus-visible": {
            outline: "none !important",
            boxShadow: "none !important"
          }
        },
        ".MuiDivider-root": {
          margin: theme2.spacing(1, 0)
        },
        // Indent sublevels, ugly but needed to avoid issues with hover
        "& .MuiList-root": {
          paddingTop: 0,
          paddingBottom: 0,
          "& .MuiListItem-root": {
            paddingLeft: theme2.spacing(4)
          },
          "& .MuiList-root": {
            "& .MuiListItem-root": {
              paddingLeft: theme2.spacing(6)
            },
            "& .MuiList-root": {
              "& .MuiListItem-root": {
                paddingLeft: theme2.spacing(8)
              },
              "& .MuiList-root": {
                "& .MuiListItem-root": {
                  paddingLeft: theme2.spacing(10)
                }
              }
            }
          }
        },
        "& .MuiListItemButton-root": {
          "&:focus-visible": {
            backgroundColor: "transparent"
          }
        }
      })
    }
  },
  // List Item
  MuiListItemText: {
    defaultProps: {
      primaryTypographyProps: {
        variant: "body2",
        noWrap: true,
        component: "span"
      },
      secondaryTypographyProps: { variant: "caption" }
    },
    styleOverrides: {
      root: ({ theme: theme2 }) => ({
        paddingRight: theme2.spacing(2),
        "& + .MuiBox-root": {
          marginRight: theme2.spacing(1)
        }
      })
    }
  },
  MuiListItemIcon: {
    styleOverrides: {
      root: ({ theme: theme2 }) => ({
        display: "flex",
        alignItems: "center",
        gap: theme2.spacing(2),
        "& .MuiSvgIcon-root": {
          fontSize: ICON_SIZE_LARGE
        },
        ".MuiMenuItem-root.MuiButtonBase-root &": {
          minWidth: ICON_SIZE_MEDIUM
        }
      })
    }
  },
  MuiListItemAvatar: {
    styleOverrides: {
      root: ({ theme: theme2 }) => ({
        "& .MuiAvatar-root": {
          height: theme2.spacing(4),
          width: theme2.spacing(4)
        },
        "& .MuiSvgIcon-root": {
          fontSize: ICON_SIZE_MEDIUM
        }
      })
    }
  },
  // Tabs
  MuiTabs: {
    styleOverrides: {
      root: ({ theme: theme2 }) => ({
        boxSizing: "content-box",
        boxShadow: `0 1px 0 0 ${theme2.palette.black[12]}`
      }),
      vertical: () => ({
        borderBottom: 0,
        boxShadow: "none"
      })
    }
  },
  // Tab
  MuiTab: {
    defaultProps: {
      iconPosition: "start"
    },
    styleOverrides: {
      root: ({ theme: theme2 }) => ({
        minHeight: theme2.spacing(6),
        minWidth: theme2.spacing(6),
        padding: theme2.spacing(0, 2),
        paddingTop: "2px",
        borderBottom: "2px solid transparent",
        ...theme2.typography.subtitle2,
        color: theme2.palette.text.primary,
        transition: "border 300ms cubic-bezier(0.4, 0, 0.2, 1)",
        "&:hover": {
          borderBottomColor: theme2.palette.text.primary
        },
        "&:focus-visible": {
          outline: `none !important`,
          boxShadow: `inset 0 0 0 2px ${theme2.palette.primary.main} !important`,
          borderRadius: `${theme2.shape.borderRadius}px ${theme2.shape.borderRadius}px 0 0`
        },
        "&.Mui-selected": {
          pointerEvents: "none",
          "& svg:not(.doNotFillIcon) path": {
            fill: theme2.palette.primary.main
          }
        },
        ".MuiTabs-vertical &": {
          paddingTop: 0,
          borderBottom: 0,
          paddingLeft: "2px",
          borderRight: "2px solid transparent",
          "&:hover": {
            borderRightColor: theme2.palette.text.primary
          }
        }
      }),
      wrapped: () => ({
        maxWidth: "240px"
      })
    }
  },
  // Breadcrumbs
  MuiBreadcrumbs: {
    styleOverrides: {
      li: ({ theme: theme2 }) => ({
        "& .MuiTypography-root": {
          ...theme2.typography.body2,
          display: "flex",
          flexDirection: "row",
          alignItems: "center"
        },
        "& .MuiSvgIcon-root": {
          fontSize: ICON_SIZE_MEDIUM,
          marginRight: theme2.spacing(1)
        }
      }),
      separator: ({ theme: theme2 }) => ({
        marginLeft: theme2.spacing(0.5),
        marginRight: theme2.spacing(0.5)
      })
    }
  },
  // Links
  MuiLink: {
    defaultProps: {
      underline: "hover"
    },
    styleOverrides: {
      root: () => ({
        cursor: "pointer"
      })
    }
  }
};
const calendarSize = 35;
const dropdownHeight = 39.5;
const datePickersOverrides = {
  // https://mui.com/x/react-date-pickers/date-picker/#customization
  MuiDatePicker: {
    defaultProps: {
      slotProps: {
        popper: { placement: "bottom-end" },
        textField: {
          InputLabelProps: {
            shrink: true
          }
        }
      },
      slots: {
        openPickerIcon: EventOutlined,
        clearIcon: Cancel
      }
    }
  },
  MuiDateCalendar: {
    defaultProps: {
      dayOfWeekFormatter: (weekday) => `${weekday.toLocaleDateString("en-US", { weekday: "short" })}`,
      slots: {
        rightArrowIcon: ChevronRightOutlined,
        leftArrowIcon: ChevronLeftOutlined,
        switchViewIcon: ExpandMoreOutlined
      }
    },
    styleOverrides: {
      root: ({ ownerState, theme: theme2 }) => {
        var _a2, _b2, _c2, _d2, _e2, _f2, _g2, _h2, _i;
        return {
          width: theme2.spacing(calendarSize),
          height: theme2.spacing(dropdownHeight),
          maxHeight: theme2.spacing(dropdownHeight),
          // Year only view
          ...((_a2 = ownerState.views) == null ? void 0 : _a2.includes("year")) && !((_b2 = ownerState.views) == null ? void 0 : _b2.includes("month")) && !((_c2 = ownerState.views) == null ? void 0 : _c2.includes("day")) && {
            height: theme2.spacing(33.5),
            // 268px
            maxHeight: theme2.spacing(33.5)
          },
          // Month only view
          ...((_d2 = ownerState.views) == null ? void 0 : _d2.includes("month")) && !((_e2 = ownerState.views) == null ? void 0 : _e2.includes("year")) && !((_f2 = ownerState.views) == null ? void 0 : _f2.includes("day")) && {
            height: theme2.spacing(29),
            // 232px
            maxHeight: theme2.spacing(29),
            "& .MuiPickersCalendarHeader-labelContainer": {
              cursor: "default"
            }
          },
          // Day only view
          ...((_g2 = ownerState.views) == null ? void 0 : _g2.includes("day")) && !((_h2 = ownerState.views) == null ? void 0 : _h2.includes("year")) && !((_i = ownerState.views) == null ? void 0 : _i.includes("month")) && {
            "& .MuiPickersCalendarHeader-labelContainer": {
              cursor: "default"
            }
          },
          "& .MuiYearCalendar-root, & .MuiMonthCalendar-root": {
            gap: theme2.spacing(0.5),
            width: theme2.spacing(calendarSize),
            padding: theme2.spacing(1, 2)
          },
          "& .MuiPickersYear-root": {
            flexBasis: "22.5%"
          },
          "& .MuiPickersMonth-root": {
            flexBasis: "31.1%"
          },
          "& .MuiPickersYear-yearButton, & .MuiPickersMonth-monthButton, & .MuiPickersDay-root": {
            width: "100%",
            height: theme2.spacing(4),
            margin: 0,
            padding: 0,
            ...theme2.typography.button,
            borderRadius: theme2.shape.borderRadius,
            "&:hover": {
              backgroundColor: theme2.palette.action.hover
            },
            "&.Mui-selected": {
              backgroundColor: theme2.palette.primary.background,
              color: theme2.palette.primary.main,
              "&:focus": {
                backgroundColor: theme2.palette.primary.background
              },
              "&:hover": {
                backgroundColor: theme2.palette.action.hover
              }
            },
            "&.Mui-disabled": {
              color: theme2.palette.text.disabled
            }
          },
          "& .MuiPickersDay-root": {
            margin: theme2.spacing(0.25)
          }
        };
      }
    }
  },
  MuiPickersPopper: {
    styleOverrides: {
      paper: ({ theme: theme2 }) => ({
        marginBottom: theme2.spacing(0.5)
      })
    }
  },
  MuiYearCalendar: {
    styleOverrides: {
      root: ({ theme: theme2 }) => ({
        maxHeight: theme2.spacing(33.5)
        // 268px
      })
    }
  },
  MuiPickersCalendarHeader: {
    styleOverrides: {
      root: ({ theme: theme2 }) => ({
        maxHeight: theme2.spacing(4),
        minHeight: theme2.spacing(4),
        margin: 0,
        padding: theme2.spacing(1, 1, 1, 2),
        boxSizing: "content-box",
        "& .MuiIconButton-root": {
          borderRadius: theme2.shape.borderRadius
        },
        "& .MuiPickersArrowSwitcher-spacer": {
          width: theme2.spacing(4)
        }
      }),
      label: ({ theme: theme2 }) => ({
        ...theme2.typography.subtitle2
      }),
      switchViewButton: ({ theme: theme2 }) => ({
        width: theme2.spacing(4),
        height: theme2.spacing(4)
      })
    }
  },
  MuiDayCalendar: {
    styleOverrides: {
      header: ({ theme: theme2 }) => ({
        margin: theme2.spacing(0, 2)
      }),
      weekContainer: () => ({
        margin: 0
      }),
      weekDayLabel: ({ theme: theme2 }) => ({
        flex: 1,
        ...theme2.typography.caption,
        fontWeight: theme2.typography.fontWeightRegular,
        color: theme2.palette.text.secondary
      })
    }
  },
  MuiPickersDay: {
    styleOverrides: {
      root: ({ theme: theme2 }) => ({
        width: `${theme2.spacing(4)} !important`,
        height: theme2.spacing(4),
        "&:focus": {
          backgroundColor: "transparent"
        }
      }),
      today: ({ theme: theme2 }) => ({
        border: `1px solid ${theme2.palette.default.outlinedBorder}`,
        "&:hover, &:selected": {
          borderColor: theme2.palette.primary.light
        },
        "&:not(.Mui-selected)": {
          borderColor: theme2.palette.default.outlinedBorder
        },
        "&.Mui-selected": {
          borderColor: theme2.palette.primary.light,
          "&:focus": {
            borderColor: theme2.palette.primary.light
          }
        },
        "&.Mui-disabled": {
          color: theme2.palette.text.disabled,
          borderColor: theme2.palette.default.outlinedBorder,
          backgroundColor: "transparent",
          "&.Mui-selected": {
            opacity: "1 !important",
            color: theme2.palette.text.disabled,
            backgroundColor: "transparent",
            borderColor: theme2.palette.default.outlinedBorder
          }
        }
      })
    }
  },
  MuiTimePicker: {
    defaultProps: {
      views: ["hours"],
      format: "hh:mm a",
      ampm: true,
      viewRenderers: {
        hours: renderDigitalClockTimeView
      },
      timeSteps: { minutes: 30 },
      slotProps: {
        actionBar: { actions: [] }
        // Remove ok button at bottom
      },
      slots: {
        clearIcon: Cancel,
        digitalClockItem: (props) => {
          return /* @__PURE__ */ jsx(MenuItem, { ...props, disableRipple: true });
        }
      }
    }
  },
  MuiDateTimePicker: {
    defaultProps: {
      views: ["year", "month", "day", "hours"],
      format: "MM/dd/yyyy hh:mm a",
      ampm: true,
      viewRenderers: {
        hours: renderDigitalClockTimeView
      },
      timeSteps: { minutes: 30 },
      slotProps: {
        popper: {
          placement: "bottom-end"
        },
        actionBar: { actions: [] }
        // Remove ok button at bottom
      },
      slots: {
        openPickerIcon: EventOutlined,
        clearIcon: Cancel,
        digitalClockItem: (props) => {
          return /* @__PURE__ */ jsx(MenuItem, { ...props, disableRipple: true });
        }
      }
    }
  },
  MuiDigitalClock: {
    defaultProps: {
      timeStep: 30,
      ampm: true
    },
    styleOverrides: {
      root: ({ theme: theme2 }) => ({
        minWidth: theme2.spacing(15)
        // 120px defined in design specs
      }),
      list: ({ theme: theme2 }) => ({
        ".MuiPopper-root &": {
          maxHeight: theme2.spacing(dropdownHeight),
          paddingBottom: theme2.spacing(1)
        }
      })
    }
  }
};
const feedbackOverrides = {
  // SnackBar
  MuiSnackbar: {
    defaultProps: {
      anchorOrigin: {
        vertical: "bottom",
        horizontal: "center"
      }
    }
  },
  // Skeleton
  MuiSkeleton: {
    defaultProps: {
      animation: "wave",
      variant: "rounded"
    },
    styleOverrides: {
      root: ({ theme: theme2 }) => ({
        backgroundColor: theme2.palette.black[8]
      }),
      rounded: ({ theme: theme2 }) => ({
        borderRadius: theme2.spacing(0.5)
      }),
      text: ({ theme: theme2 }) => ({
        borderRadius: theme2.spacing(0.5)
      }),
      wave: ({ theme: theme2 }) => ({
        "&::after": {
          background: `linear-gradient( 90deg, transparent, ${theme2.palette.black[4]}, transparent )`
        }
      })
    }
  },
  // Alert
  MuiAlert: {
    defaultProps: {
      severity: "neutral",
      iconMapping: {
        success: /* @__PURE__ */ jsx(CheckCircleOutlined, {}),
        neutral: /* @__PURE__ */ jsx(InfoOutlined, {})
      }
    },
    styleOverrides: {
      root: ({ theme: theme2 }) => ({
        borderRadius: theme2.spacing(1),
        alignSelf: "start",
        width: "100%",
        padding: theme2.spacing(1.5)
      }),
      icon: ({ theme: theme2 }) => ({
        height: theme2.spacing(3),
        display: "flex",
        alignItems: "center",
        padding: 0,
        marginRight: theme2.spacing(1),
        svg: {
          width: ICON_SIZE_MEDIUM,
          height: ICON_SIZE_MEDIUM
        }
      }),
      action: () => ({
        paddingTop: 0,
        marginRight: 0
      }),
      message: ({ theme: theme2 }) => ({
        paddingTop: theme2.spacing(0.5),
        paddingBottom: 0,
        ...theme2.typography.caption
      })
    },
    variants: [
      {
        props: { severity: "neutral" },
        style: ({ theme: theme2 }) => ({
          backgroundColor: theme2.palette.default.background,
          color: theme2.palette.text.primary,
          ".MuiAlert-message": {
            "& :not(.MuiAlertTitle-root)": {
              color: theme2.palette.text.secondary
            },
            a: {
              color: `${theme2.palette.primary.main} !important`
            }
          },
          ".MuiAlert-icon": {
            color: theme2.palette.text.primary
          }
        })
      }
    ]
  },
  // AlertTitle
  MuiAlertTitle: {
    defaultProps: {
      variant: "body2"
    },
    styleOverrides: {
      root: ({ theme: theme2 }) => ({
        marginBottom: theme2.spacing(0.5),
        fontWeight: theme2.typography.fontWeightBold,
        color: "inherit"
      })
    }
  }
};
const surfacesOverrides = {
  // AppBar
  MuiAppBar: {
    styleOverrides: {
      root: ({ theme: theme2 }) => ({
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "space-between",
        height: APPBAR_SIZE,
        backgroundColor: theme2.palette.brand.navyBlue,
        color: theme2.palette.common.white,
        boxShadow: theme2.shadows[0],
        "& .MuiToolbar-root": {
          justifyContent: "space-between",
          width: "100%",
          padding: theme2.spacing(0, 1),
          minHeight: APPBAR_SIZE
        },
        "& .MuiAvatar-root": {
          width: theme2.spacing(4),
          height: theme2.spacing(4)
        }
      })
    }
  },
  // MuiAccordion
  MuiAccordion: {
    defaultProps: {
      disableGutters: true,
      elevation: 0
    },
    styleOverrides: {
      root: ({ theme: theme2 }) => ({
        ...theme2.typography.body2,
        backgroundColor: "transparent",
        boxShadow: `inset 0 -1px 0 0 ${theme2.palette.divider}`,
        "&:last-of-type": {
          boxShadow: "none"
        },
        "&::before": {
          content: "none"
        },
        "&.Mui-disabled": {
          backgroundColor: "transparent"
        }
      })
    }
  },
  // MuiAccordionSummary
  MuiAccordionSummary: {
    defaultProps: {
      expandIcon: /* @__PURE__ */ jsx(ExpandMoreOutlined, {})
    },
    styleOverrides: {
      root: ({ theme: theme2 }) => ({
        ...theme2.typography.button,
        "&.Mui-disabled": {
          opacity: 1,
          color: theme2.palette.text.disabled
        },
        "&.Mui-focusVisible": {
          backgroundColor: "transparent",
          borderRadius: theme2.shape.borderRadius
        }
      }),
      expandIconWrapper: ({ theme: theme2 }) => ({
        "& svg": {
          color: theme2.palette.text.secondary,
          ".Mui-disabled &": {
            color: theme2.palette.text.disabled
          }
        }
      })
    }
  },
  // MuiAccordionDetails
  MuiAccordionDetails: {
    styleOverrides: {
      root: ({ theme: theme2 }) => ({
        paddingBottom: theme2.spacing(3)
      })
    }
  }
};
const layoutOverrides = {
  // Stack
  MuiStack: {
    defaultProps: {
      useFlexGap: true
    }
  }
};
const CssBaseline = {
  // Accessibility focus (keyboard only)
  "*:focus-visible": {
    outline: `2px solid ${(_a = commonPalette.primary) == null ? void 0 : _a.main} !important`,
    boxShadow: `0 0 0 4px ${(_b = commonPalette.primary) == null ? void 0 : _b.background} !important`,
    borderRadius: "4px"
  },
  // Custom scrollbars
  "*::-webkit-scrollbar": {
    position: "fixed"
  },
  "*::-webkit-scrollbar:vertical": {
    width: "5px"
  },
  "*::-webkit-scrollbar:horizontal": {
    height: "5px"
  },
  "*::-webkit-scrollbar-track": {
    boxShadow: "none",
    background: "transparent"
  },
  "*::-webkit-scrollbar-thumb": {
    borderRadius: "3px",
    background: (_c = commonPalette.action) == null ? void 0 : _c.focus,
    outline: "none"
  },
  // iOS Search clear button
  'input[type="search"]::-webkit-search-cancel-button': {
    WebkitAppearance: "none",
    appearance: "none",
    height: getSpacing(2),
    width: getSpacing(2),
    display: "block",
    backgroundImage: `url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAYAAAA7MK6iAAAAn0lEQVR42u3UMQrDMBBEUZ9WfQqDmm22EaTyjRMHAlM5K+Y7lb0wnUZPIKHlnutOa+25Z4D++MRBX98MD1V/trSppLKHqj9TTBWKcoUqffbUcbBBEhTjBOV4ja4l4OIAZThEOV6jHO8ARXD+gPPvKMABinGOrnu6gTNUawrcQKNCAQ7QeTxORzle3+sDfjJpPCqhJh7GixZq4rHcc9l5A9qZ+WeBhgEuAAAAAElFTkSuQmCC)`,
    backgroundRepeat: "no-repeat",
    backgroundSize: getSpacing(2)
  },
  // Mapbox controls
  ".mapboxgl-ctrl.mapboxgl-ctrl-attrib": {
    padding: getSpacing(0, 1),
    borderRadius: getSpacing(0.5, 0, 0, 0),
    "& .mapboxgl-ctrl-attrib-inner": {
      ...themeTypography.overline,
      textTransform: "none",
      letterSpacing: "0.75px",
      "& a": {
        color: (_d = commonPalette.primary) == null ? void 0 : _d.main
      }
    },
    "&.mapboxgl-compact": {
      backgroundColor: "transparent",
      right: getSpacing(0.5),
      bottom: getSpacing(2.5),
      // Mobile
      "@media (max-width: 600px)": {
        bottom: getSpacing(0.5)
      },
      "& .mapboxgl-ctrl-attrib-button": {
        backgroundImage: `url("data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns='http://www.w3.org/2000/svg'%20height='24'%20viewBox='0%200%2024%2024'%20width='24'%3E%3Cg%3E%3Crect%20fill='none'%20height='24'%20width='24'%20x='0'/%3E%3C/g%3E%3Cg%3E%3Cg%3E%3Cg%3E%3Cpath%20d='M11.88,9.14c1.28,0.06,1.61,1.15,1.63,1.66h1.79c-0.08-1.98-1.49-3.19-3.45-3.19C9.64,7.61,8,9,8,12.14%20c0,1.94,0.93,4.24,3.84,4.24c2.22,0,3.41-1.65,3.44-2.95h-1.79c-0.03,0.59-0.45,1.38-1.63,1.44C10.55,14.83,10,13.81,10,12.14%20C10,9.25,11.28,9.16,11.88,9.14z%20M12,2C6.48,2,2,6.48,2,12s4.48,10,10,10s10-4.48,10-10S17.52,2,12,2z%20M12,20c-4.41,0-8-3.59-8-8%20s3.59-8,8-8s8,3.59,8,8S16.41,20,12,20z'%20fill='${(_e = commonPalette.text) == null ? void 0 : _e.secondary}'/%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
        backgroundColor: "rgba(255,255,255,.8)",
        top: "auto",
        bottom: 0,
        right: 0,
        "&:not(:disabled):hover": {
          backgroundColor: "rgba(255,255,255,.8)"
        }
      },
      "& .mapboxgl-ctrl-attrib-inner": {
        backgroundColor: "rgba(255,255,255,.8)",
        padding: getSpacing(0.5, 1),
        borderRadius: getSpacing(1.5),
        marginRight: getSpacing(2.5),
        color: (_f = commonPalette.text) == null ? void 0 : _f.secondary
      },
      "&.mapboxgl-compact-show": {
        "& .mapboxgl-ctrl-attrib-button": {
          backgroundImage: `url("data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns='http://www.w3.org/2000/svg'%20height='24'%20viewBox='0%200%2024%2024'%20width='24'%3E%3Cpath%20d='M0%200h24v24H0z'%20fill='none'/%3E%3Cpath%20d='M19%206.41L17.59%205%2012%2010.59%206.41%205%205%206.41%2010.59%2012%205%2017.59%206.41%2019%2012%2013.41%2017.59%2019%2019%2017.59%2013.41%2012z'%20fill='white'/%3E%3C/svg%3E")`,
          backgroundColor: (_g = commonPalette.common) == null ? void 0 : _g.black,
          "&:not(:disabled):hover": {
            backgroundColor: (_h = commonPalette.common) == null ? void 0 : _h.black
          }
        }
      }
    }
  }
};
const cartoThemeOptions = {
  themeName: "CARTO",
  breakpoints: {
    keys: ["xs", "sm", "md", "lg", "xl"],
    values: {
      xs: BREAKPOINTS.XS,
      // 320 - 599
      sm: BREAKPOINTS.SM,
      // 600 - 959
      md: BREAKPOINTS.MD,
      // 960 - 1279
      lg: BREAKPOINTS.LG,
      // 1280 - 1599
      xl: BREAKPOINTS.XL
      // 1600+
    },
    unit: "px",
    step: 5
    // For more information about use this helper functions: https://mui.com/material-ui/customization/breakpoints/#css-media-queries
    // up: f d(),
    // down: f down(),
    // between: f p(),
    // only: f only(),
    // width: f width(),
  },
  direction: "ltr",
  mixins: {
    // gutters: f gutters(),
    toolbar: {
      minHeight: 56,
      "@media (min-width:0px) and (orientation: landscape)": {
        minHeight: 48
      },
      "@media (min-width:600px)": {
        minHeight: 56
      }
    }
  },
  palette: commonPalette,
  shadows: themeShadows,
  typography: themeTypography,
  spacingValue: SPACING,
  // For situations where we can't use theme.spacing(), mainly math calculations.er
  spacing: SPACING,
  // For custom spacing: https://material-ui.com/customization/spacing/#custom-spacing
  shape: {
    borderRadius: 4
  },
  transitions: {
    easing: {
      easeInOut: "cubic-bezier(0.4, 0, 0.2, 1)",
      easeOut: "cubic-bezier(0.0, 0, 0.2, 1)",
      easeIn: "cubic-bezier(0.4, 0, 1, 1)",
      sharp: "cubic-bezier(0.4, 0, 0.6, 1)"
    },
    duration: {
      shortest: 150,
      shorter: 200,
      short: 250,
      standard: 300,
      complex: 375,
      enteringScreen: 225,
      leavingScreen: 195
    }
    // create: f create(), => Research
    // getAutoHeightDuration: f getAutoHeightDuration(), => Research
  },
  zIndex: {
    mobileStepper: 1e3,
    speedDial: 1050,
    appBar: 1100,
    drawer: 1200,
    modal: 1300,
    snackbar: 1400,
    tooltip: 1500
  },
  // Styles and props overrides for components
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        ...CssBaseline
      }
    },
    ...buttonsOverrides,
    ...formsOverrides,
    ...navigationOverrides,
    ...dataDisplayOverrides,
    ...feedbackOverrides,
    ...surfacesOverrides,
    ...datePickersOverrides,
    ...layoutOverrides
  }
};
const theme = responsiveFontSizes(createTheme(cartoThemeOptions));
export {
  APPBAR_SIZE,
  BREAKPOINTS,
  ICON_SIZE_LARGE,
  ICON_SIZE_MEDIUM,
  ICON_SIZE_SMALL,
  MENU_ITEM_SIZE_DEFAULT,
  MENU_ITEM_SIZE_DENSE,
  h as MENU_ITEM_SIZE_EXTENDED,
  MENU_LIST_MAX_SIZE,
  N as NOTIFICATION_DURATION_IN_MS,
  SPACING,
  cartoThemeOptions,
  g as getCartoColorStylePropsForItem,
  getSpacing,
  theme
};
